(function(){
var options={};(function(exports,require){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SINGER_PREFERENCE_VALUES = exports.GENRE_VALUES = exports.MOOD_VALUES = exports.OCCASION_VALUES = exports.RELATIONSHIP_VALUES = exports.SINGER_PREFERENCES = exports.GENRES = exports.MOODS = exports.OCCASIONS = exports.RELATIONSHIPS = void 0;
exports.labelForOccasion = labelForOccasion;
exports.titleWordForOccasion = titleWordForOccasion;
exports.labelForRelationship = labelForRelationship;
exports.labelForMood = labelForMood;
exports.labelForGenre = labelForGenre;
exports.labelForSingerPreference = labelForSingerPreference;
exports.RELATIONSHIPS = [
    { value: "spouse", label: "Spouse" },
    { value: "partner", label: "Partner" },
    { value: "mother", label: "Mother" },
    { value: "father", label: "Father" },
    { value: "child", label: "Child" },
    { value: "sibling", label: "Sibling" },
    { value: "grandparent", label: "Grandparent" },
    { value: "friend", label: "Friend" },
    { value: "other", label: "Other (I'll describe)" },
];
exports.OCCASIONS = [
    { value: "birthday", label: "Birthday" },
    { value: "anniversary", label: "Anniversary" },
    { value: "wedding", label: "Wedding" },
    { value: "engagement", label: "Engagement / proposal" },
    { value: "mothers_day", label: "Mother's Day" },
    { value: "fathers_day", label: "Father's Day" },
    { value: "valentines", label: "Valentine's Day" },
    { value: "christmas", label: "Christmas" },
    { value: "graduation", label: "Graduation" },
    { value: "memorial", label: "Memorial / in memory" },
    { value: "pet_memorial", label: "Pet memorial" },
    { value: "just_because", label: "Just because" },
    { value: "i_love_you", label: "I Love You" },
    { value: "missing_you", label: "Missing You" },
    { value: "thank_you", label: "Thank You" },
    { value: "apology", label: "Apology" },
    { value: "friendship", label: "Friendship" },
    { value: "milestone", label: "Milestone" },
    { value: "retirement", label: "Retirement" },
    { value: "other", label: "Other (I'll describe)" },
];
exports.MOODS = [
    { value: "joyful", label: "Joyful" },
    { value: "tender", label: "Tender" },
    { value: "romantic", label: "Romantic" },
    { value: "nostalgic", label: "Nostalgic" },
    { value: "celebratory", label: "Celebratory" },
    { value: "hopeful", label: "Hopeful" },
    { value: "somber", label: "Somber" },
    { value: "heartfelt", label: "Heartfelt" },
    { value: "sentimental", label: "Sentimental" },
    { value: "uplifting", label: "Uplifting" },
    { value: "playful", label: "Playful" },
    { value: "peaceful", label: "Peaceful" },
    { value: "reflective", label: "Reflective" },
];
exports.GENRES = [
    { value: "pop", label: "Pop" },
    { value: "gospel", label: "Gospel / Prayer" },
    { value: "acoustic", label: "Acoustic / singer-songwriter" },
    { value: "folk", label: "Folk" },
    { value: "country", label: "Country" },
    { value: "rnb", label: "R&B / soul" },
    { value: "rock", label: "Rock" },
    { value: "indie", label: "Indie" },
    { value: "jazz", label: "Jazz" },
    { value: "blues", label: "Blues" },
    { value: "soul", label: "Soul" },
    { value: "hip_hop", label: "Hip-hop" },
    { value: "musical_theater", label: "Broadway" },
    { value: "classical_strings", label: "Classical" },
    { value: "reggae", label: "Reggae" },
    { value: "bluegrass", label: "Bluegrass" },
    { value: "oldies", label: "Oldies" },
    { value: "eighties", label: "80s" },
    { value: "worship", label: "Worship" },
    { value: "lullaby", label: "Lullaby" },
    { value: "let_maya_decide", label: "Let Maya decide" },
];
exports.SINGER_PREFERENCES = [
    { value: "no_preference", label: "No preference" },
    { value: "female", label: "Female vocalist" },
    { value: "male", label: "Male vocalist" },
    { value: "duet", label: "Duet" },
];
exports.RELATIONSHIP_VALUES = exports.RELATIONSHIPS.map((r) => r.value);
exports.OCCASION_VALUES = exports.OCCASIONS.map((o) => o.value);
exports.MOOD_VALUES = exports.MOODS.map((m) => m.value);
exports.GENRE_VALUES = exports.GENRES.map((g) => g.value);
exports.SINGER_PREFERENCE_VALUES = exports.SINGER_PREFERENCES.map((s) => s.value);
function labelForOccasion(value) {
    var _a;
    if (!value)
        return "";
    const match = exports.OCCASIONS.find((o) => o.value === value);
    return (_a = match === null || match === void 0 ? void 0 : match.label) !== null && _a !== void 0 ? _a : value;
}
const OCCASION_TITLE_WORDS = {
    other: "",
    just_because: "",
    missing_you: "",
    i_love_you: "Love",
    thank_you: "Thank-You",
    pet_memorial: "Memorial",
};
function titleWordForOccasion(value) {
    if (!value)
        return "";
    const match = exports.OCCASIONS.find((o) => o.value === value);
    if (!match)
        return "";
    const override = OCCASION_TITLE_WORDS[match.value];
    if (override !== undefined)
        return override;
    return match.label.split(/[/(]/)[0].trim();
}
function labelForRelationship(value) {
    var _a;
    if (!value)
        return "";
    const match = exports.RELATIONSHIPS.find((r) => r.value === value);
    return (_a = match === null || match === void 0 ? void 0 : match.label) !== null && _a !== void 0 ? _a : value;
}
function labelForMood(value) {
    var _a;
    if (!value)
        return "";
    const match = exports.MOODS.find((m) => m.value === value);
    return (_a = match === null || match === void 0 ? void 0 : match.label) !== null && _a !== void 0 ? _a : value;
}
function labelForGenre(value) {
    var _a;
    if (!value)
        return "";
    const match = exports.GENRES.find((g) => g.value === value);
    return (_a = match === null || match === void 0 ? void 0 : match.label) !== null && _a !== void 0 ? _a : value;
}
function labelForSingerPreference(value) {
    var _a;
    if (!value)
        return "";
    const match = exports.SINGER_PREFERENCES.find((s) => s.value === value);
    return (_a = match === null || match === void 0 ? void 0 : match.label) !== null && _a !== void 0 ? _a : value;
}

})(options,function(id){var deps={};if(!Object.prototype.hasOwnProperty.call(deps,id))throw new Error("Missing quiz dependency");return deps[id];});
var normalize={};(function(exports,require){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeGenre = normalizeGenre;
exports.normalizeMood = normalizeMood;
exports.normalizeSingerPreference = normalizeSingerPreference;
exports.normalizeOccasion = normalizeOccasion;
exports.normalizeRelationship = normalizeRelationship;
exports.canonicalizeBriefOptions = canonicalizeBriefOptions;
const song_options_ts_1 = require("./song-options.ts");
function slug(raw) {
    return raw
        .trim()
        .toLowerCase()
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
}
const GENRE_ALIASES = {
    r_and_b: "rnb",
    r_and_b_soul: "rnb",
    rnb_soul: "rnb",
    rhythm_and_blues: "rnb",
    rand_b: "rnb",
    hiphop: "hip_hop",
    hip_hop_rap: "hip_hop",
    rap: "hip_hop",
    classical: "classical_strings",
    strings: "classical_strings",
    orchestral: "classical_strings",
    classical_orchestral: "classical_strings",
    musical_theatre: "musical_theater",
    broadway: "musical_theater",
    singer_songwriter: "acoustic",
    acoustic_singer_songwriter: "acoustic",
    gospel_prayer: "gospel",
    prayer: "gospel",
    christian: "worship",
    ccm: "worship",
    praise: "worship",
    praise_and_worship: "worship",
    doo_wop: "oldies",
    "50s": "oldies",
    "60s": "oldies",
    fifties: "oldies",
    sixties: "oldies",
    "80s": "eighties",
    synth_pop: "eighties",
    synthpop: "eighties",
    nursery: "lullaby",
    nursery_rhyme: "lullaby",
    motown: "soul",
    soul_motown: "soul",
    let_maya_choose: "let_maya_decide",
    maya_decide: "let_maya_decide",
    surprise_me: "let_maya_decide",
    no_preference: "let_maya_decide",
    any: "let_maya_decide",
};
const MOOD_ALIASES = {
    happy: "joyful",
    emotional: "heartfelt",
    sad: "somber",
    funny: "playful",
    calm: "peaceful",
    love: "romantic",
    loving: "romantic",
    proud: "celebratory",
    grateful: "sentimental",
};
const SINGER_ALIASES = {
    female_vocalist: "female",
    male_vocalist: "male",
    woman: "female",
    man: "male",
    she: "female",
    he: "male",
    either: "no_preference",
    any: "no_preference",
    both: "duet",
    two_voices: "duet",
    duo: "duet",
};
const OCCASION_ALIASES = {
    mothers_day: "mothers_day",
    mother_s_day: "mothers_day",
    fathers_day: "fathers_day",
    father_s_day: "fathers_day",
    valentine_s_day: "valentines",
    valentines_day: "valentines",
    valentine: "valentines",
    xmas: "christmas",
    in_memory: "memorial",
    in_memoriam: "memorial",
    remembrance: "memorial",
    proposal: "engagement",
    engagement_proposal: "engagement",
    i_love_you_just_because: "just_because",
    no_occasion: "just_because",
    because: "just_because",
};
const RELATIONSHIP_ALIASES = {
    husband: "spouse",
    wife: "spouse",
    hubby: "spouse",
    boyfriend: "partner",
    girlfriend: "partner",
    fiance: "partner",
    fiancee: "partner",
    son: "child",
    daughter: "child",
    sister: "sibling",
    brother: "sibling",
    grandmother: "grandparent",
    grandfather: "grandparent",
    grandma: "grandparent",
    grandpa: "grandparent",
    nana: "grandparent",
    best_friend: "friend",
    bestie: "friend",
};
function normalize(raw, canonical, aliases) {
    if (typeof raw !== "string")
        return null;
    const trimmed = raw.trim();
    if (!trimmed)
        return null;
    if (canonical.includes(trimmed))
        return trimmed;
    const s = slug(trimmed);
    const bySlug = canonical.find((c) => slug(c) === s);
    if (bySlug)
        return bySlug;
    return Object.hasOwn(aliases, s) ? aliases[s] : null;
}
function normalizeGenre(raw) {
    return normalize(raw, song_options_ts_1.GENRE_VALUES, GENRE_ALIASES);
}
function normalizeMood(raw) {
    return normalize(raw, song_options_ts_1.MOOD_VALUES, MOOD_ALIASES);
}
function normalizeSingerPreference(raw) {
    return normalize(raw, song_options_ts_1.SINGER_PREFERENCE_VALUES, SINGER_ALIASES);
}
function normalizeOccasion(raw) {
    return normalize(raw, song_options_ts_1.OCCASION_VALUES, OCCASION_ALIASES);
}
function normalizeRelationship(raw) {
    return normalize(raw, song_options_ts_1.RELATIONSHIP_VALUES, RELATIONSHIP_ALIASES);
}
function canonicalizeBriefOptions(input) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const warnings = [];
    const genre = normalizeGenre(input.genre);
    if (((_a = input.genre) === null || _a === void 0 ? void 0 : _a.trim()) && !genre) {
        warnings.push({ field: "genre", raw: input.genre.trim() });
    }
    const mood = normalizeMood(input.mood);
    if (((_b = input.mood) === null || _b === void 0 ? void 0 : _b.trim()) && !mood) {
        warnings.push({ field: "mood", raw: input.mood.trim() });
    }
    const singer = normalizeSingerPreference(input.singer_preference);
    if (((_c = input.singer_preference) === null || _c === void 0 ? void 0 : _c.trim()) && !singer) {
        warnings.push({ field: "singer_preference", raw: input.singer_preference.trim() });
    }
    const occasion = (_f = (_d = normalizeOccasion(input.occasion)) !== null && _d !== void 0 ? _d : (_e = input.occasion) === null || _e === void 0 ? void 0 : _e.trim()) !== null && _f !== void 0 ? _f : null;
    const relationship = (_j = (_g = normalizeRelationship(input.recipient_relationship)) !== null && _g !== void 0 ? _g : (_h = input.recipient_relationship) === null || _h === void 0 ? void 0 : _h.trim()) !== null && _j !== void 0 ? _j : null;
    if (warnings.length > 0) {
        console.warn("[brief-normalize] unrecognized option values", { warnings });
    }
    return {
        genre,
        mood,
        singer_preference: singer,
        occasion,
        recipient_relationship: relationship,
        warnings,
    };
}

})(normalize,function(id){var deps={"./song-options.ts":options};if(!Object.prototype.hasOwnProperty.call(deps,id))throw new Error("Missing quiz dependency");return deps[id];});
var picks={};(function(exports,require){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STYLE_PICKS = void 0;
exports.groupForRelationship = groupForRelationship;
exports.bucketForOccasion = bucketForOccasion;
exports.pickStyles = pickStyles;
const brief_normalize_ts_1 = require("../brief-normalize.ts");
const GROUP_OF_LABEL = {
    Daughter: "child", Son: "child", "Daughter-in-law": "child", "Son-in-law": "child",
    Granddaughter: "grandchild", Grandson: "grandchild", Niece: "grandchild", Nephew: "grandchild",
    Mom: "elder", Dad: "elder", Grandma: "elder", Grandpa: "elder", Grandparent: "elder",
    Husband: "spouse", Wife: "spouse", Partner: "spouse", "Fiancé(e)": "spouse", "Fiancé": "spouse",
    Boyfriend: "dating", Girlfriend: "dating",
    Friend: "friend", Sister: "friend", Brother: "friend", Cousin: "friend", Sibling: "friend",
    Myself: "self",
};
const GROUP_OF_VALUE = {
    spouse: "spouse", partner: "spouse",
    mother: "elder", father: "elder", grandparent: "elder",
    child: "child",
    sibling: "friend", friend: "friend",
};
function own(map, key) {
    return Object.hasOwn(map, key) ? map[key] : undefined;
}
function groupForRelationship(relationship) {
    const text = (relationship !== null && relationship !== void 0 ? relationship : "").trim();
    if (!text)
        return "friend";
    const exact = own(GROUP_OF_LABEL, text);
    if (exact)
        return exact;
    const lower = text.toLowerCase();
    const chip = Object.keys(GROUP_OF_LABEL).find((k) => k.toLowerCase() === lower);
    if (chip)
        return GROUP_OF_LABEL[chip];
    const value = (0, brief_normalize_ts_1.normalizeRelationship)(text);
    return (value && own(GROUP_OF_VALUE, value)) || "friend";
}
const BUCKET_OF_OCCASION = {
    birthday: "birthday", just_because: "birthday", milestone: "birthday",
    thank_you: "birthday", christmas: "birthday", mothers_day: "birthday",
    fathers_day: "birthday", other: "birthday",
    anniversary: "love", i_love_you: "love", valentines: "love", wedding: "love",
    engagement: "love", missing_you: "love", apology: "love",
    memorial: "memory", pet_memorial: "memory",
    graduation: "life", retirement: "life", friendship: "life",
};
function bucketForOccasion(occasionValue) {
    var _a;
    return (_a = own(BUCKET_OF_OCCASION, (occasionValue !== null && occasionValue !== void 0 ? occasionValue : "").trim())) !== null && _a !== void 0 ? _a : "birthday";
}
exports.STYLE_PICKS = {
    child: {
        birthday: ["Pop", "Country", "R&B", "80s"],
        love: ["Pop", "Country", "Acoustic", "80s"],
        memory: ["Gospel", "Acoustic", "Country", "Worship"],
        life: ["Pop", "Country", "Broadway", "80s"],
    },
    grandchild: {
        birthday: ["Pop", "Country", "Lullaby", "Reggae"],
        love: ["Pop", "Acoustic", "Country", "R&B"],
        memory: ["Gospel", "Acoustic", "Country", "Worship"],
        life: ["Pop", "Country", "Hip-hop", "80s"],
    },
    elder: {
        birthday: ["Country", "Gospel", "Oldies", "Worship"],
        love: ["Country", "Oldies", "Acoustic", "Soul"],
        memory: ["Gospel", "Worship", "Acoustic", "Country"],
        life: ["Country", "Oldies", "Bluegrass", "Gospel"],
    },
    spouse: {
        birthday: ["Country", "Pop", "80s", "R&B"],
        love: ["Country", "Acoustic", "Oldies", "R&B"],
        memory: ["Gospel", "Acoustic", "Country", "Classical"],
        life: ["Country", "Pop", "Bluegrass", "80s"],
    },
    dating: {
        birthday: ["Pop", "R&B", "Indie", "Reggae"],
        love: ["Pop", "R&B", "Indie", "Acoustic"],
        memory: ["Acoustic", "Gospel", "Pop", "Country"],
        life: ["Pop", "Hip-hop", "R&B", "Indie"],
    },
    friend: {
        birthday: ["Pop", "Reggae", "Country", "Hip-hop"],
        love: ["Pop", "Acoustic", "Country", "Soul"],
        memory: ["Gospel", "Acoustic", "Country", "Folk"],
        life: ["Pop", "Hip-hop", "Reggae", "80s"],
    },
    self: {
        birthday: ["Pop", "Country", "Indie", "Gospel"],
        love: ["Pop", "Country", "Acoustic", "Indie"],
        memory: ["Gospel", "Acoustic", "Country", "Worship"],
        life: ["Pop", "Country", "Broadway", "Indie"],
    },
};
function withSlotFour(row, style) {
    if (row.includes(style))
        return [...row];
    return [...row.slice(0, 3), style];
}
function pickStyles(relationship, occasionValue) {
    const group = groupForRelationship(relationship);
    const occasion = (occasionValue !== null && occasionValue !== void 0 ? occasionValue : "").trim();
    const row = exports.STYLE_PICKS[group][bucketForOccasion(occasion)];
    if (occasion === "christmas")
        return withSlotFour(row, "Oldies");
    if (occasion === "fathers_day" && group === "elder")
        return withSlotFour(row, "Bluegrass");
    return [...row];
}

})(picks,function(id){var deps={"../brief-normalize.ts":normalize};if(!Object.prototype.hasOwnProperty.call(deps,id))throw new Error("Missing quiz dependency");return deps[id];});
var model={};(function(exports,require){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMPT_SEP = exports.TRAITS_LABEL = exports.MESSAGE_LABEL = exports.MEMORY_LABEL = exports.MESSAGE_SCREEN = exports.MEMORY_SCREEN = exports.STORY_SCREEN = exports.STORY_PROMPTED_SCREEN = exports.TRAITS_SCREEN = exports.PHASES = exports.SCREENS = exports.SURPRISE = exports.ALL_STYLES = exports.VOICE_VALUE = exports.MOOD_VALUE = exports.GENRE_VALUE = exports.STORY_SCREEN_COPY = exports.OCC_OTHER_LABEL = exports.ALL_OCCASIONS = exports.OCCASION_VALUE = exports.OWN_TRAIT_PLACEHOLDER = exports.IN_LAW = exports.KID = exports.PARENT = exports.SIBLING = exports.SPOUSE = exports.REL_LEGACY = exports.REL_CHIPS = exports.QUIZ2_STORAGE_KEY = void 0;
exports.relationshipKey = relationshipKey;
exports.pillForTypedRelationship = pillForTypedRelationship;
exports.genderFor = genderFor;
exports.herHim = herHim;
exports.signOffsFor = signOffsFor;
exports.callNameConfig = callNameConfig;
exports.familyAlternatives = familyAlternatives;
exports.looksLikeFirstName = looksLikeFirstName;
exports.occasionOrder = occasionOrder;
exports.storyHasRealDetail = storyHasRealDetail;
exports.recommendedStyles = recommendedStyles;
exports.moodOptions = moodOptions;
exports.resolveSurpriseStyle = resolveSurpriseStyle;
exports.resolveSurpriseMood = resolveSurpriseMood;
exports.quizProgress = quizProgress;
exports.normalizeScreenParam = normalizeScreenParam;
exports.traitsFor = traitsFor;
exports.storyPlaceholder = storyPlaceholder;
exports.messagePlaceholder = messagePlaceholder;
exports.storyPrompts = storyPrompts;
exports.sanitizeTraits = sanitizeTraits;
exports.traitKey = traitKey;
exports.matchTraitPill = matchTraitPill;
exports.traitsInDrawOrder = traitsInDrawOrder;
exports.relationshipNote = relationshipNote;
exports.assembleStory = assembleStory;
exports.storyWithoutPronunciation = storyWithoutPronunciation;
exports.splitStory = splitStory;
const brief_normalize_ts_1 = require("../brief-normalize.ts");
const style_picks_ts_1 = require("./style-picks.ts");
exports.QUIZ2_STORAGE_KEY = "songbond_preview_session";
exports.REL_CHIPS = [
    "Daughter", "Husband", "Granddaughter", "Wife",
    "Son", "Friend", "Grandson", "Sister",
    "Brother", "Boyfriend", "Girlfriend", "Partner",
    "Mom", "Dad", "Grandma", "Grandpa",
    "Niece", "Nephew",
    "Daughter-in-law", "Son-in-law",
    "Cousin", "Fiancé(e)",
    "Myself", "Someone else",
];
exports.REL_LEGACY = ["Sibling", "Grandparent", "Fiancé"];
const GENDER = {
    Wife: "female", Girlfriend: "female", Mom: "female", Daughter: "female",
    Grandma: "female", Granddaughter: "female",
    Sister: "female", Niece: "female",
    Husband: "male", Boyfriend: "male", Dad: "male", Son: "male",
    Grandpa: "male", Grandson: "male", Brother: "male", Nephew: "male",
    Myself: "self",
    "Daughter-in-law": "female", "Son-in-law": "male",
};
function foldText(raw) {
    return raw.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
}
function relationshipKey(raw) {
    return foldText(raw).replace(/^my\s+/, "").replace(/[^a-z]/g, "");
}
const TYPED_PILL = {
    daughterinlaw: "Daughter-in-law",
    daughternlaw: "Daughter-in-law",
    daugtherinlaw: "Daughter-in-law",
    soninlaw: "Son-in-law",
    sonnlaw: "Son-in-law",
};
function pillForTypedRelationship(raw) {
    const key = relationshipKey(raw);
    return Object.prototype.hasOwnProperty.call(TYPED_PILL, key) ? TYPED_PILL[key] : null;
}
function genderFor(relationship) {
    var _a;
    return (_a = GENDER[relationship]) !== null && _a !== void 0 ? _a : "neutral";
}
function herHim(relationship) {
    const g = genderFor(relationship);
    return g === "female" ? "her" : g === "male" ? "him" : "them";
}
exports.SPOUSE = new Set([
    "Husband", "Wife", "Partner", "Boyfriend", "Girlfriend",
    "Fiancé(e)", "Fiancé",
]);
exports.SIBLING = new Set(["Sister", "Brother", "Sibling"]);
exports.PARENT = new Set(["Mom", "Dad"]);
const GRAND = new Set(["Grandma", "Grandpa", "Grandparent"]);
exports.KID = new Set([
    "Son", "Daughter", "Grandson", "Granddaughter", "Niece", "Nephew",
]);
exports.IN_LAW = new Set(["Daughter-in-law", "Son-in-law"]);
const SIGN_PARENT = new Set(["Daughter", "Son"]);
const SIGN_GRANDPARENT = new Set(["Granddaughter", "Grandson"]);
const SIGN_AUNTUNCLE = new Set(["Niece", "Nephew"]);
const SIGN_DESCENDANT = new Set([
    "Mom", "Dad", "Grandma", "Grandpa", "Grandparent",
]);
const SIGN_SIBLING = new Set(["Sister", "Brother", "Sibling", "Cousin"]);
function signOffsFor(relationship, senderFirst) {
    const rel = relationship.trim();
    let group;
    if (exports.SPOUSE.has(rel)) {
        group = ["All my love", "Yours, always", "Love you, always"];
    }
    else if (SIGN_PARENT.has(rel)) {
        group = ["Love, Mom", "Love, Dad", "Mom and Dad"];
    }
    else if (SIGN_GRANDPARENT.has(rel)) {
        group = ["Love, Grandma", "Love, Grandpa", "Grandma and Grandpa"];
    }
    else if (SIGN_AUNTUNCLE.has(rel)) {
        group = ["Love, Auntie", "Love, Uncle", "Your aunt and uncle"];
    }
    else if (SIGN_DESCENDANT.has(rel)) {
        group = ["Love always", "Your daughter", "Your son"];
    }
    else if (SIGN_SIBLING.has(rel)) {
        group = ["Love always", "Your sister", "Your brother"];
    }
    else if (rel === "Myself") {
        return [];
    }
    else {
        group = ["With love", "Love always", "Always"];
    }
    const first = senderFirst.trim();
    const out = first ? [`Love, ${first}`, ...group] : group;
    return Array.from(new Set(out)).slice(0, 4);
}
function callNameConfig(relationship) {
    const fixed = {
        Grandma: { title: "What do you call her?", sub: "Use what you’d naturally say to her.", quick: ["Grandma", "Nana", "Grammy", "Gran", "Nonna"], placeholder: "Or type your own" },
        Grandpa: { title: "What do you call him?", sub: "Use what you’d naturally say to him.", quick: ["Grandpa", "Papa", "Grandad", "Pops", "Pop-Pop"], placeholder: "Or type your own" },
        Mom: { title: "What do you call her?", sub: "Use what belongs in the song.", quick: ["Mom", "Mum", "Mama", "Mommy"], placeholder: "Or type your own" },
        Dad: { title: "What do you call him?", sub: "Use what belongs in the song.", quick: ["Dad", "Daddy", "Papa", "Pops"], placeholder: "Or type your own" },
    };
    if (fixed[relationship])
        return fixed[relationship];
    if (relationship === "Daughter-in-law")
        return { title: "What\u2019s her name?", sub: "Use the name you naturally say to her.", quick: [], placeholder: "e.g. Emma" };
    if (relationship === "Son-in-law")
        return { title: "What\u2019s his name?", sub: "Use the name you naturally say to him.", quick: [], placeholder: "e.g. Jake" };
    if (exports.SPOUSE.has(relationship))
        return { title: `What do you call ${herHim(relationship)}?`, sub: "Usually a first name works best. A nickname is fine too.", quick: [], placeholder: "e.g. Claire, Em, Babe" };
    if (exports.KID.has(relationship)) {
        const g = genderFor(relationship);
        const poss = g === "female" ? "her" : g === "male" ? "his" : "their";
        return { title: `What’s ${poss} name?`, sub: `Use the name you naturally say to ${herHim(relationship)}.`, quick: [], placeholder: "e.g. Emma" };
    }
    if (relationship === "Friend")
        return { title: "What do you call them?", sub: "First name or nickname — whatever feels natural.", quick: [], placeholder: "e.g. Jess, JJ" };
    if (exports.SIBLING.has(relationship))
        return { title: "What do you call them?", sub: "The name or nickname that belongs in the song.", quick: [], placeholder: "e.g. Jake, Sis" };
    if (relationship === "Myself")
        return { title: "What should the song call you?", sub: "The name or nickname that feels most like you.", quick: [], placeholder: "e.g. Alex, AJ" };
    return { title: "What should the song call them?", sub: "Name, nickname or title — whatever feels natural.", quick: [], placeholder: "e.g. Coach, Uncle Rob, Sarah" };
}
function familyAlternatives(relationship) {
    switch (relationship) {
        case "Grandma": return ["Grandma", "Nana", "Grammy", "Gran"];
        case "Grandpa": return ["Grandpa", "Papa", "Grandad", "Pops"];
        case "Mom": return ["Mom", "Mum", "Mama"];
        case "Dad": return ["Dad", "Papa", "Pops"];
        default: return [];
    }
}
const FAMILY_WORDS = new Set([
    "mom", "mum", "mama", "mommy", "dad", "daddy", "papa", "pops",
    "grandma", "grandpa", "nana", "grammy", "gran", "grandad", "pop-pop", "nonna",
]);
exports.OWN_TRAIT_PLACEHOLDER = "e.g. Great listener";
function looksLikeFirstName(value) {
    const x = value.trim().toLowerCase();
    if (!x)
        return false;
    return /^[a-z][a-z'-]{2,}$/.test(x) && !FAMILY_WORDS.has(x);
}
exports.OCCASION_VALUE = {
    "Just Because": "just_because",
    "I Love You": "i_love_you",
    "Birthday": "birthday",
    "Anniversary": "anniversary",
    "Missing You": "missing_you",
    "Thank You": "thank_you",
    "Apology": "apology",
    "Wedding": "wedding",
    "Friendship": "friendship",
    "In Memory": "memorial",
    "Milestone": "milestone",
    "Proposal": "engagement",
    "Retirement": "retirement",
    "Graduation": "graduation",
};
exports.ALL_OCCASIONS = [
    "Just Because", "I Love You", "Birthday", "Anniversary", "Missing You",
    "Thank You", "Apology", "Wedding", "Friendship", "In Memory",
    "Milestone", "Proposal", "Retirement", "Graduation",
];
exports.OCC_OTHER_LABEL = "Something else…";
function occasionOrder(relationship) {
    const LEAD = ["Birthday", "Anniversary", "In Memory"];
    if (exports.SPOUSE.has(relationship))
        return ["Anniversary", "Birthday", "In Memory", "I Love You", "Just Because", "Wedding", "Proposal"];
    if (exports.PARENT.has(relationship))
        return [...LEAD, "Thank You", "Just Because", "Milestone", "Retirement"];
    if (GRAND.has(relationship))
        return [...LEAD, "Thank You", "Just Because", "Milestone"];
    if (exports.KID.has(relationship))
        return [...LEAD, "Graduation", "Milestone", "Just Because", "Wedding"];
    if (relationship === "Friend" || exports.SIBLING.has(relationship))
        return [...LEAD, "Friendship", "Thank You", "Just Because", "Milestone"];
    if (relationship === "Myself")
        return ["Just Because", "Milestone", "Birthday", "Graduation", "Retirement"];
    return [...LEAD, "Thank You", "Just Because", "Milestone"];
}
exports.STORY_SCREEN_COPY = {
    qualities: {
        title: "What makes them special?",
        sub: "Describe their character and the qualities you love most",
        hint: "For best results, please include 1\u20132 sentences.",
        label: "Their beautiful qualities",
        placeholder: "Are they patient, wise, funny, protective, encouraging? What makes them the incredible person they are?",
    },
    memories: {
        title: "Share your favorite memories",
        sub: "Share a favorite moment",
        hint: "For best results, please include 1\u20132 sentences.",
        label: "Special moments together",
        placeholder: "Share how you met, special years, inside jokes, or moments that made your relationship unique...",
    },
    message: {
        title: "A message from your heart",
        sub: "Add a short personal note",
        hint: "For best results, please include 1\u20132 sentences.",
        label: "Special message",
        placeholder: "What do you want them to know, feel, or remember?",
    },
};
function storyHasRealDetail(story, starters = []) {
    let v = story;
    for (const s of starters)
        v = v.split(s).join(" ");
    return v.replace(/[.…,;:!?\s]+/g, "").length >= 3;
}
exports.GENRE_VALUE = {
    Gospel: "gospel", Country: "country", Acoustic: "acoustic", Pop: "pop",
    "R&B": "rnb", Rock: "rock", Jazz: "jazz", Folk: "folk", Blues: "blues",
    Soul: "soul",
    Indie: "indie", "Hip-hop": "hip_hop", Broadway: "musical_theater",
    Classical: "classical_strings", Reggae: "reggae", Bluegrass: "bluegrass",
    Oldies: "oldies", "80s": "eighties", Worship: "worship", Lullaby: "lullaby",
};
exports.MOOD_VALUE = {
    Heartfelt: "heartfelt", Romantic: "romantic", Joyful: "joyful",
    Sentimental: "sentimental", Uplifting: "uplifting", Playful: "playful",
    Peaceful: "peaceful", Reflective: "reflective", Hopeful: "hopeful",
};
exports.VOICE_VALUE = {
    "Female voice": "female", "Male voice": "male", "Surprise Me": "no_preference",
};
exports.ALL_STYLES = [
    "Gospel", "Country", "Acoustic", "Pop", "R&B", "Rock", "Jazz", "Folk",
    "Blues", "Soul",
    "Indie", "Hip-hop", "Broadway", "Classical", "Reggae", "Bluegrass",
    "Oldies", "80s", "Worship", "Lullaby",
];
exports.SURPRISE = "Surprise Me";
function recommendedStyles(relationship, occasion) {
    var _a, _b;
    const text = occasion.trim();
    const value = (_b = (_a = (Object.hasOwn(exports.OCCASION_VALUE, text) ? exports.OCCASION_VALUE[text] : null)) !== null && _a !== void 0 ? _a : (0, brief_normalize_ts_1.normalizeOccasion)(text)) !== null && _b !== void 0 ? _b : "other";
    return (0, style_picks_ts_1.pickStyles)(relationship, value);
}
function moodOptions(relationship, occasionLabel) {
    if (occasionLabel === "In Memory")
        return ["Peaceful", "Reflective", "Hopeful", "Sentimental"];
    if (exports.SPOUSE.has(relationship))
        return ["Romantic", "Heartfelt", "Joyful", "Playful", "Sentimental"];
    if (exports.KID.has(relationship))
        return ["Heartfelt", "Joyful", "Uplifting", "Playful"];
    return ["Heartfelt", "Joyful", "Sentimental", "Uplifting", "Reflective"];
}
function resolveSurpriseStyle(relationship, occasionLabel) {
    return recommendedStyles(relationship, occasionLabel)[0];
}
function resolveSurpriseMood(relationship, occasionLabel) {
    return moodOptions(relationship, occasionLabel)[0];
}
exports.SCREENS = [
    "relationship", "callname", "occasion",
    "sound",
    "traits", "memory",
];
function quizProgress(screen) {
    const total = exports.SCREENS.length;
    const step = screen === "review" ? total + 1 : exports.SCREENS.indexOf(screen) + 1;
    return { step: Math.min(step, total), total, percent: Math.round((step / (total + 1)) * 100) };
}
exports.PHASES = {
    relationship: { name: "About them", caption: "A few quick details", segments: [0.34, 0, 0, 0] },
    callname: { name: "About them", caption: "Make it personal", segments: [0.68, 0, 0, 0] },
    occasion: { name: "About them", caption: "One more thing", segments: [1, 0, 0, 0] },
    sound: { name: "The sound", caption: "Shape the music", segments: [1, 0.8, 0, 0] },
    traits: { name: "Their story", caption: "This makes the song theirs", segments: [1, 1, 0.5, 0] },
    memory: { name: "Their story", caption: "A moment worth singing about", segments: [1, 1, 1, 0] },
    review: { name: "Ready", caption: "One quick check", segments: [1, 1, 1, 0.94] },
};
function normalizeScreenParam(raw) {
    const first = Array.isArray(raw) ? raw[0] : raw;
    const n = Number.parseInt(first !== null && first !== void 0 ? first : "1", 10);
    if (!Number.isFinite(n) || n < 1)
        return 1;
    return Math.min(n, exports.SCREENS.length);
}
const TRAITS_ROMANTIC = [
    "Loving", "Kind", "My best friend", "Makes me laugh", "Patient",
    "Generous", "Strong", "Always there", "Thoughtful", "Gentle", "Honest",
    "Supportive", "Warm", "My safe place",
    "Stubborn", "Terrible dancer", "Always cold", "Fixes everything",
    "Never lets me win", "Cries at films", "Can't sit still", "Best hugs",
    "Sings in the car", "Steals the covers", "Always hungry",
    "Makes the coffee", "Never on time", "Overpacks", "Talks to the dog",
    "Terrible at lying", "Plans everything", "Hopeless romantic",
    "Still holds my hand", "Bad at surprises", "Snores", "Remembers it all",
];
const TRAITS_PARENT = [
    "Loving", "Selfless", "Kind", "Hardworking", "Always there", "Strong",
    "Generous", "Wise", "Patient", "Proud of me", "Gentle", "Forgiving",
    "My biggest fan", "Devoted", "Stubborn", "Bad jokes", "Always early",
    "Lists for everything", "Same advice twice", "Sunday roast",
    "Always busy",
];
const TRAITS_PARENT_PAST = [
    "Fed everyone", "Never sat down", "Worried out loud",
    "Sang while cooking", "Kept my drawings", "Gave up everything",
    "Fixed everything", "Waited up", "Asked for nothing",
    "Made it from scratch", "Drove me everywhere", "Cried at everything",
    "Danced in the kitchen", "Called to check", "Never complained",
];
const TRAITS_GRAND = [
    "Loving", "Kind", "Wise", "Generous", "Gentle", "Full of stories",
    "Family's heart", "Proud of me", "Patient", "Devoted", "Warm",
    "Steady", "Comforting", "Same story twice", "So stubborn",
    "Always gardening", "Sharp as a tack", "Wicked humour",
    "Same old coat", "Best roast dinner", "Their own chair",
    "Sweets in the pocket",
];
const TRAITS_GRAND_PAST = [
    "Never judged", "Always had sweets", "Fixed everything",
    "Sang the old songs", "Fed everyone twice", "Called every Sunday",
    "Kept everything", "Kept every photo", "Never sat still",
    "Slipped me money", "Knew everyone", "Wrote real letters",
    "Danced at weddings", "Whistled always",
];
const TRAITS_KID = [
    "Kind", "Funny", "Brave", "Clever", "Loving", "Full of joy", "Gentle",
    "Determined", "Curious", "Generous", "Thoughtful", "Bright", "Caring",
    "Big heart",
    "Never stops talking", "Asks why forever", "Dances everywhere",
    "Stubborn", "Big feelings", "Friends with all", "Bad at losing",
    "An old soul", "Fearless", "Collects everything", "Draws on walls",
    "Sings made-up songs", "Hates bedtime", "Loves animals",
    "Tells long stories", "Copies everything", "Always muddy",
    "Runs everywhere", "Wants to help", "Laughs at nothing",
    "Never still", "Asks for one more",
];
const TRAITS_SIBLING = [
    "My best friend", "Funny", "Loyal", "Kind", "Has my back", "Generous",
    "Strong", "Talented", "Thoughtful", "Protective", "Honest", "Fun",
    "Supportive", "My first call",
    "Partner in crime", "Knows my secrets", "Stubborn", "Always right",
    "Steals my clothes", "Never texts back", "Competitive", "Total chaos",
    "Started every fight", "Covered for me", "Calls at odd hours",
    "Remembers it all", "A bad influence", "Always loudest",
    "Beat me at everything", "Steals my food", "Knows me too well",
    "Softer than they look", "Makes me cry laughing", "Copies my haircut",
    "Never lost a game", "Would fight for me",
];
const TRAITS_FRIEND = [
    "Loyal", "Funny", "Kind", "Generous", "Always there", "Genuine",
    "Big-hearted", "Easy to talk to", "Thoughtful", "Warm", "Honest", "Fun",
    "Dependable", "One in a million",
    "Always shows up", "Always late", "Brutally honest", "Answers at 3am",
    "Never judges", "Remembers it all", "Up for anything", "Feeds everyone",
    "Terrible dancer", "Loud", "Quietly steady", "Competitive",
    "Good bad influence", "Sends the memes", "First one there",
    "Last to leave", "Cries at films", "Best advice", "Plans nothing",
    "Terrible at goodbyes", "Knows me too well", "Never forgets a birthday",
];
const TRAITS_SELF = [
    "Kind", "Strong", "Loyal", "Funny", "Hopeful", "Honest", "Caring",
    "Determined", "Generous", "Patient", "Grateful", "Resilient", "Loving",
    "Enough",
    "Stubborn", "Still learning", "Restless", "Tired but trying",
    "A dreamer", "A fighter", "Soft-hearted", "Too honest", "Overthinks",
    "Never gives up", "Quiet", "Curious", "Bad at asking help",
    "Always planning", "Kinder than I was", "Learning to rest",
    "Hard on myself", "Getting there", "Says yes too often",
    "Better than I was", "Not finished yet", "Proud of myself",
];
const TRAITS_GENERAL = [
    "Kind", "Funny", "Generous", "Loving", "Loyal", "Patient", "Strong",
    "Big-hearted", "Thoughtful", "Gentle", "Honest", "Warm", "Genuine",
    "Selfless",
    "Stubborn", "Fearless", "Always early", "Feeds everyone",
    "Never sits still", "Brutally honest", "Quietly strong",
    "Wickedly funny", "Terrible dancer", "Remembers it all",
    "Never complains", "Fixes everything", "Tells long stories",
    "Up for anything", "Always busy", "Good in a crisis", "Sings badly",
    "Best advice", "Never forgets a birthday", "Makes everyone welcome",
    "Laughs at everything", "Bad at sitting down",
];
function traitsFor(relationship, occasionLabel) {
    const memorial = occasionLabel === "In Memory";
    if (exports.SPOUSE.has(relationship))
        return TRAITS_ROMANTIC;
    if (exports.PARENT.has(relationship))
        return memorial ? [...TRAITS_PARENT, ...TRAITS_PARENT_PAST] : TRAITS_PARENT;
    if (GRAND.has(relationship))
        return memorial ? [...TRAITS_GRAND, ...TRAITS_GRAND_PAST] : TRAITS_GRAND;
    if (exports.KID.has(relationship))
        return TRAITS_KID;
    if (exports.SIBLING.has(relationship))
        return TRAITS_SIBLING;
    if (relationship === "Friend")
        return TRAITS_FRIEND;
    if (relationship === "Myself")
        return TRAITS_SELF;
    return TRAITS_GENERAL;
}
exports.TRAITS_SCREEN = {
    title: "What are they like?",
};
exports.STORY_PROMPTED_SCREEN = {
    title: "What should the song know?",
    sub: "Share what you remember \u2014 even one little detail can make their song feel deeply personal.",
    hint: "Every box here is optional.",
    elseLabel: "Something else",
    elsePlaceholder: "An inside joke, a place that matters, a line the song should say\u2026",
};
exports.STORY_SCREEN = {
    title: "Anything else the song should know?",
    sub: "A story, a favourite memory, an inside joke, something it must say.",
    hint: "Optional \u2014 but one real detail is what makes it theirs.",
    label: "In your own words",
    placeholder: "How you met, a moment you both remember, a phrase only they say, something you\u2019ve never told them\u2026",
};
function storyPlaceholder(relationship, occasionLabel) {
    if (occasionLabel === "In Memory")
        return "A memory that brings a smile, something they always said, what they meant to you\u2026";
    if (relationship === "Daughter-in-law")
        return "The day she joined the family, a moment she made you proud, what you love most about her\u2026";
    if (relationship === "Son-in-law")
        return "The day he joined the family, a moment he made you proud, what you love most about him\u2026";
    if (relationship === "Boyfriend" || relationship === "Girlfriend")
        return "How you met, the moment you started falling, what you love most about them\u2026";
    if (exports.SPOUSE.has(relationship))
        return "How you met, a ritual only you two have, the moment you knew\u2026";
    if (exports.PARENT.has(relationship))
        return "A memory from growing up, something they did you never forgot, the phrase they always say\u2026";
    if (GRAND.has(relationship))
        return "A memory from when you were small, what they taught you, something they always say\u2026";
    if (exports.SIBLING.has(relationship))
        return "Growing up together, a story only you two laugh at, what makes them one of a kind\u2026";
    if (exports.KID.has(relationship))
        return "Something they loved as a little kid, a moment you were proudest, what you hope they always remember\u2026";
    if (relationship === "Friend")
        return "How you became friends, a story only you two laugh at, what makes them one of a kind\u2026";
    if (relationship === "Myself")
        return "A chapter that mattered, what it took to get here, a line you live by\u2026";
    return exports.STORY_SCREEN.placeholder;
}
exports.MEMORY_SCREEN = {
    title: "Share your favorite memories",
    sub: "Share a favorite moment",
    hint: "For best results, please include 1\u20132 sentences.",
    label: "Special moments together",
};
exports.MESSAGE_SCREEN = {
    title: "A message from your heart",
    sub: "Add a short personal note",
    hint: "For best results, please include 1\u20132 sentences.",
    label: "Special message",
};
function messagePlaceholder(relationship, occasionLabel) {
    if (occasionLabel === "In Memory")
        return "What you\u2019d tell them if you could, what you carry from them, what you never got to say\u2026";
    if (relationship === "Boyfriend" || relationship === "Girlfriend")
        return "What you love about them, what you hope is ahead, the thing you don\u2019t say often enough\u2026";
    if (exports.SPOUSE.has(relationship))
        return "What you still love, what you\u2019d choose again, the thing you don\u2019t say often enough\u2026";
    if (exports.PARENT.has(relationship))
        return "What you never quite said thank you for, what you hope they know\u2026";
    if (GRAND.has(relationship))
        return "What they gave you that stayed, what you want them to hear while you can say it\u2026";
    if (exports.SIBLING.has(relationship))
        return "What they\u2019ve been to you, the thing you\u2019d never say to their face\u2026";
    if (exports.KID.has(relationship))
        return "What you\u2019re proud of, what you hope they remember when things are hard\u2026";
    if (relationship === "Friend")
        return "What they\u2019ve been through with you, why they matter, what you\u2019ve never told them\u2026";
    if (relationship === "Myself")
        return "What you want to remember about now, what you\u2019d tell yourself, what you\u2019re still carrying\u2026";
    return "What you want them to know, feel, or remember\u2026";
}
function storyPrompts(relationship, occasionLabel, name) {
    const n = name.trim();
    const them = n || "them";
    const they = n || "they";
    const says = n ? `${n} always says` : "they always say";
    if (occasionLabel === "In Memory") {
        return [
            { key: "smile", question: "A memory that brings a smile", label: "A memory that brings a smile", placeholder: "The kitchen radio, the long drives, the garden\u2026" },
            { key: "said", question: `Something ${n ? `${n} always said` : "they always said"}`, label: "Something they always said", placeholder: "The phrase everyone still repeats\u2026" },
            { key: "meant", question: `What did ${they} mean to you?`, label: "What they meant to me", placeholder: "In your own words \u2014 a few are enough." },
        ];
    }
    const dating = relationship === "Boyfriend" || relationship === "Girlfriend";
    let base;
    if (exports.SPOUSE.has(relationship)) {
        base = dating
            ? [
                { key: "met", question: "How did you two meet?", label: "How we met", placeholder: "A bus stop, a wedding, third-period math\u2026" },
                { key: "falling", question: "The moment you started falling", label: "When I started falling", placeholder: "The second coffee, the call that went long\u2026" },
                { key: "love", question: `What do you love most about ${them}?`, label: "What I love most", placeholder: "The laugh before the joke lands\u2026" },
            ]
            : [
                { key: "met", question: "How did you two meet?", label: "How we met", placeholder: "A bus stop, a wedding, third-period math\u2026" },
                { key: "ritual", question: "A little ritual only you two have", label: "A ritual only we have", placeholder: "Sunday coffee, the goodnight text, the song in the car\u2026" },
                { key: "love", question: `What do you love most about ${them}?`, label: "What I love most", placeholder: "The laugh before the joke lands\u2026" },
            ];
    }
    else if (exports.PARENT.has(relationship)) {
        base = [
            { key: "growingup", question: "A memory from growing up", label: "A memory from growing up", placeholder: "Sunday pancakes, the kitchen radio, school mornings\u2026" },
            { key: "neverforgot", question: `Something ${they} did that you never forgot`, label: "What I never forgot", placeholder: "The extra shift, the all-night drive, never missing a game\u2026" },
            { key: "says", question: `Something ${says}`, label: "Something they always say", placeholder: "The phrase everyone teases them about\u2026" },
        ];
    }
    else if (GRAND.has(relationship)) {
        base = [
            { key: "small", question: "A memory from when you were small", label: "When I was small", placeholder: "The kitchen, the stories, the garden, the sweet tin\u2026" },
            { key: "taught", question: `What did ${they} teach you?`, label: "What they taught me", placeholder: "Patience, card games, the secret recipe\u2026" },
            { key: "says", question: `Something ${says}`, label: "Something they always say", placeholder: "The blessing, the warning, the joke\u2026" },
        ];
    }
    else if (exports.SIBLING.has(relationship)) {
        base = [
            { key: "together", question: "A memory from growing up together", label: "Growing up together", placeholder: "The shared room, the fights, the cover-ups\u2026" },
            { key: "laugh", question: "A story only you two laugh at", label: "A story only we laugh at", placeholder: "The road trip, the wrong train\u2026" },
            { key: "onekind", question: `What makes ${them} one of a kind?`, label: "One of a kind because", placeholder: "Shows up before you ask\u2026" },
        ];
    }
    else if (exports.KID.has(relationship)) {
        base = [
            { key: "littlekid", question: `Something ${them} loved as a little kid`, label: "As a little kid", placeholder: "Dinosaurs, the blue blanket, that one song\u2026" },
            { key: "proud", question: "A moment you were proudest", label: "A moment I was proudest", placeholder: "The recital, the first day, the comeback\u2026" },
            { key: "remember", question: `What do you hope ${they} always remember${n ? "s" : ""}?`, label: "What I hope they remember", placeholder: "That home is always here\u2026" },
        ];
    }
    else if (relationship === "Friend") {
        base = [
            { key: "became", question: "How did you become friends?", label: "How we became friends", placeholder: "College, the first job, next door\u2026" },
            { key: "laugh", question: "A story only you two laugh at", label: "A story only we laugh at", placeholder: "The road trip, the wrong train\u2026" },
            { key: "onekind", question: `What makes ${them} one of a kind?`, label: "One of a kind because", placeholder: "Shows up before you ask\u2026" },
        ];
    }
    else {
        base = [
            { key: "shared", question: "A memory you share", label: "A memory we share", placeholder: "A trip, a season, an ordinary day that stuck\u2026" },
            { key: "says", question: `Something ${says}`, label: "Something they always say", placeholder: "The phrase everyone knows them by\u2026" },
            { key: "onekind", question: `What makes ${them} one of a kind?`, label: "One of a kind because", placeholder: "In a few words\u2026" },
        ];
    }
    let extra = null;
    switch (occasionLabel) {
        case "Anniversary":
        case "Wedding":
        case "Proposal":
            extra = { key: "knew", question: "The moment you knew", label: "The moment I knew", placeholder: "When it stopped being a question\u2026" };
            break;
        case "Birthday":
            extra = { key: "year", question: `What made this year ${n ? `${n}\u2019s` : "theirs"}?`, label: "What this year held", placeholder: "The new job, the marathon, the move\u2026" };
            break;
        case "Thank You":
            extra = { key: "thanks", question: `What are you thanking ${them} for?`, label: "Thank you for", placeholder: "The thing they never made a fuss about\u2026" };
            break;
        case "Missing You":
            extra = { key: "miss", question: "What do you miss most?", label: "What I miss most", placeholder: "The everyday things count double\u2026" };
            break;
        case "Apology":
            extra = { key: "know", question: `What do you want ${them} to know?`, label: "What I want them to know", placeholder: "Say it plainly \u2014 the song will carry it." };
            break;
        case "Graduation":
        case "Milestone":
        case "Retirement":
            extra = { key: "took", question: "What did it take to get here?", label: "What it took", placeholder: "The night shifts, the second tries\u2026" };
            break;
        default:
            extra = null;
    }
    return extra ? [...base, extra] : base;
}
function sanitizeTraits(value) {
    const raw = Array.isArray(value) ? value : [];
    const seen = new Set();
    const out = [];
    for (const v of raw) {
        if (typeof v !== "string")
            continue;
        const t = v.trim().replace(/\s+/g, " ").slice(0, 60);
        if (!t)
            continue;
        const k = t.toLowerCase();
        if (seen.has(k))
            continue;
        seen.add(k);
        out.push(t);
        if (out.length >= 40)
            break;
    }
    return out;
}
function traitKey(s) {
    return s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
}
function matchTraitPill(typed, shown) {
    var _a;
    const k = traitKey(typed);
    if (!k)
        return null;
    return (_a = shown.find((x) => traitKey(x) === k)) !== null && _a !== void 0 ? _a : null;
}
function traitsInDrawOrder(list, typed, selected) {
    const key = (x) => traitKey(x) || x.toLowerCase();
    const seen = new Set();
    const out = [];
    const add = (t) => {
        const k = key(t);
        if (seen.has(k))
            return;
        seen.add(k);
        out.push(t);
    };
    typed.forEach(add);
    selected.filter((t) => !list.includes(t)).forEach(add);
    list.forEach(add);
    return out;
}
function relationshipNote(relationship, senderRole) {
    const rel = (relationship !== null && relationship !== void 0 ? relationship : "").trim();
    if (!exports.IN_LAW.has(rel))
        return null;
    const sender = (senderRole !== null && senderRole !== void 0 ? senderRole : "")
        .trim()
        .toLowerCase()
        .replace(/\s*&\s*/g, " and ")
        .replace(/\s+/g, " ");
    const f = rel === "Daughter-in-law";
    const [she, her, poss, little] = f
        ? ["she", "her", "her", "my little girl"]
        : ["he", "him", "his", "my little boy"];
    let note = `IN-LAW: ${she} is the buyer's ${rel.toLowerCase()} — family by marriage, not by birth. The buyer did not raise ${her}, so no childhood memories, no "${little}", no "I watched you grow up" unless the story says so. What ${she} has brought to the family, and the welcome ${she} has found in it, is the natural ground.`;
    if (sender === "mother-in-law" || sender === "mother in law") {
        note += ` It is from ${poss} mother-in-law.`;
    }
    else if (sender === "father-in-law" || sender === "father in law") {
        note += ` It is from ${poss} father-in-law.`;
    }
    else if (sender === "mother and father-in-law") {
        note += ` It is from ${poss} mother-in-law and father-in-law, together — the narrator is never one of them alone.`;
    }
    return note;
}
exports.MEMORY_LABEL = "A memory they shared: ";
exports.MESSAGE_LABEL = "What they want the song to say: ";
exports.TRAITS_LABEL = "What they\u2019re like: ";
exports.PROMPT_SEP = ": ";
function assembleStory(parts) {
    var _a, _b;
    const out = [];
    const traits = ((_a = parts.traits) !== null && _a !== void 0 ? _a : []).map((t) => t.trim()).filter(Boolean);
    if (traits.length)
        out.push(`${exports.TRAITS_LABEL}${traits.join(", ")}`);
    for (const p of (_b = parts.prompts) !== null && _b !== void 0 ? _b : []) {
        const value = p.value.trim();
        if (value)
            out.push(`${p.label}${exports.PROMPT_SEP}${value}`);
    }
    const main = parts.story.trim();
    if (main)
        out.push(main);
    const memory = parts.memory.trim();
    if (memory)
        out.push(`${exports.MEMORY_LABEL}${memory}`);
    const message = parts.message.trim();
    if (message)
        out.push(`${exports.MESSAGE_LABEL}${message}`);
    const pron = parts.pronunciation.trim();
    if (pron) {
        const n = parts.name.trim() || "the name";
        out.push(`${n} is pronounced "${pron}" — spell it that way where it is sung if it helps the singer.`);
    }
    return out.join("\n\n");
}
function storyWithoutPronunciation(story) {
    var _a, _b;
    const raw = (story !== null && story !== void 0 ? story : "").trim();
    if (!raw)
        return "";
    const blocks = raw.split(/\n{2,}/);
    const last = (_b = (_a = blocks[blocks.length - 1]) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : "";
    if (/ is pronounced "([^"]*)"/.test(last))
        blocks.pop();
    return blocks.join("\n\n").trim();
}
function splitStory(column, promptSpec = []) {
    var _a, _b, _c, _d;
    const empty = {
        traits: [],
        prompts: {},
        story: "",
        memory: "",
        message: "",
        pronunciation: "",
    };
    const raw = (column !== null && column !== void 0 ? column : "").trim();
    if (!raw)
        return empty;
    const blocks = raw
        .split(/\n{2,}/)
        .map((b) => b.trim())
        .filter(Boolean);
    let pronunciation = "";
    const pronMatch = (_a = blocks[blocks.length - 1]) === null || _a === void 0 ? void 0 : _a.match(/ is pronounced "([^"]*)"/);
    if (pronMatch) {
        pronunciation = pronMatch[1].trim();
        blocks.pop();
    }
    let message = "";
    if ((_b = blocks[blocks.length - 1]) === null || _b === void 0 ? void 0 : _b.startsWith(exports.MESSAGE_LABEL)) {
        message = blocks.pop().slice(exports.MESSAGE_LABEL.length).trim();
    }
    let memory = "";
    if ((_c = blocks[blocks.length - 1]) === null || _c === void 0 ? void 0 : _c.startsWith(exports.MEMORY_LABEL)) {
        memory = blocks.pop().slice(exports.MEMORY_LABEL.length).trim();
    }
    let traits = [];
    if ((_d = blocks[0]) === null || _d === void 0 ? void 0 : _d.startsWith(exports.TRAITS_LABEL)) {
        traits = sanitizeTraits(blocks.shift().slice(exports.TRAITS_LABEL.length).split(","));
    }
    const prompts = {};
    while (blocks.length) {
        const head = blocks[0];
        const hit = promptSpec.find((p) => head.startsWith(p.label + exports.PROMPT_SEP));
        if (!hit)
            break;
        prompts[hit.key] = blocks.shift().slice(hit.label.length + exports.PROMPT_SEP.length).trim();
    }
    return { traits, prompts, story: blocks.join("\n\n"), memory, message, pronunciation };
}

})(model,function(id){var deps={"../brief-normalize.ts":normalize,"./style-picks.ts":picks};if(!Object.prototype.hasOwnProperty.call(deps,id))throw new Error("Missing quiz dependency");return deps[id];});
var data={};(function(exports,require){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.universalKidTraits = universalKidTraits;
exports.memoryExample = memoryExample;
exports.fromChips = fromChips;
exports.asksFrom = asksFrom;
exports.fromPlaceholder = fromPlaceholder;
const quiz2_1 = require("@/lib/preview/quiz2");
function universalKidTraits() {
    return ["Kind", "Funny", "Loving", "Big heart", "Brave", "Strong", "Generous", "Thoughtful", "Caring", "Gentle", "Full of joy", "Makes me proud",
        "Beautiful soul", "My sunshine", "Still my baby", "My best friend", "Best hugs", "Determined", "Never gives up", "Curious", "Clever", "Creative",
        "Always helping others", "Hardworking", "Grew up too fast", "An old soul", "Fearless", "Stubborn", "Big feelings", "Friends with all", "Never stops talking",
        "Dances everywhere", "Loves animals", "Tells long stories", "Bad at losing", "Laughs at nothing", "Life of the party"];
}
function memoryExample(rel, occ) {
    const g = (0, quiz2_1.genderFor)(rel), fem = g === "female", male = g === "male", P = fem ? "She" : male ? "He" : "They", obj = fem ? "her" : male ? "him" : "them";
    if (occ === "In Memory")
        return P + " whistled the same old song every morning. I still hear it when the kettle boils.";
    if (quiz2_1.SPOUSE.has(rel)) {
        if (occ === "Anniversary")
            return fem ? "Forty years ago she said yes on her mother’s porch swing. She still sits there with me every evening."
                : male ? "Forty years ago he walked me home in the rain. He still holds the umbrella over me." : "Forty years ago we shared an umbrella on our first walk home. We still do.";
        if (occ === "Wedding" || occ === "Proposal")
            return "The first time I heard " + obj + " laugh, I knew I wanted to hear it for the rest of my life.";
        if (rel === "Husband")
            return "He still brings me coffee in bed every Sunday, after all these years.";
        if (rel === "Wife")
            return "We danced in the kitchen the night we got the keys to our first home.";
        return "We got lost on our first road trip, and it turned into the best day of the summer.";
    }
    if (quiz2_1.KID.has(rel)) {
        if (occ === "Graduation")
            return P + " studied at the kitchen table every night and never once gave up.";
        if (occ === "Wedding")
            return fem ? "She walked around in my high heels when she was five. Now she’s walking down the aisle." : "He used to say he’d never get married. Then he met the one.";
        if (occ === "Milestone")
            return P + " just moved into " + (fem ? "her" : "his") + " first home, and still calls me to ask how long to cook the turkey.";
    }
    if (quiz2_1.PARENT.has(rel)) {
        if (occ === "Retirement")
            return rel === "Dad" ? "He left for work at six every morning for forty years and still made it to every one of my games."
                : "She worked nights at the hospital for thirty years and never once missed a school play.";
        if (occ === "Thank You")
            return rel === "Dad" ? "He drove three hours every weekend to fix things at my first apartment, and never let me pay for gas."
                : "She drove three hours every weekend when the baby came, and never once complained.";
    }
    if (occ === "Retirement")
        return P + " kept the whole office laughing for twenty-five years. Nobody knows how we’ll manage without " + obj + ".";
    const M = {
        Daughter: "She carried her blue blanket everywhere. Now she’s a nurse, taking care of everyone else.",
        Son: "He took apart every toy to see how it worked. Now he fixes everything in our house.",
        Granddaughter: "Every summer we picked strawberries, and she ate more than she ever saved.",
        Grandson: "He used to fall asleep on my lap after Sunday dinner. Now he’s taller than me.",
        Niece: "She calls me every week just to tell me about her day.",
        Nephew: "He still calls me for advice before every big decision.",
        "Daughter-in-law": "The first Sunday dinner she came to, she asked for my gravy recipe. Now everyone asks for hers.",
        "Son-in-law": "He asked for our blessing before he proposed, and he still calls every Sunday.",
        Mom: "She sang along to the radio every morning while she packed our lunches.",
        Dad: "He taught me to fish at the lake and never once complained about my tangled line.",
        Grandma: "Her Sunday pancakes, and the way she hummed while she made them.",
        Grandpa: "He let me steer the tractor and told everyone I was the best driver on the farm.",
        Sister: "We shared a bedroom for twelve years and still laugh at the same silly joke.",
        Brother: "We shared a bedroom for twelve years and still laugh at the same silly joke.",
        Friend: "We met at the school gate thirty years ago and have talked every week since.",
        Myself: "I went back to school at sixty and finished my degree."
    };
    return M[rel] || "The way they light up a room, and the song they always sing in the car.";
}
function fromChips(rel) {
    if (rel === "Daughter" || rel === "Son")
        return ["Mom", "Dad", "Mom and Dad"];
    if (rel === "Granddaughter" || rel === "Grandson")
        return ["Grandma", "Grandpa", "Grandma and Grandpa"];
    if (rel === "Niece" || rel === "Nephew")
        return ["Aunt", "Uncle", "Aunt and Uncle"];
    if (rel === "Mom" || rel === "Dad")
        return ["Daughter", "Son"];
    if (rel === "Grandma" || rel === "Grandpa")
        return ["Granddaughter", "Grandson", "Daughter", "Son"];
    if (rel === "Daughter-in-law" || rel === "Son-in-law")
        return ["Mother-in-law", "Father-in-law", "Mother and Father-in-law"];
    return [];
}
function asksFrom(rel) {
    return fromChips(rel).length > 0;
}
function fromPlaceholder(rel) {
    if (rel === "Daughter" || rel === "Son")
        return "e.g. Mama, Stepmom, Papa";
    if (rel === "Granddaughter" || rel === "Grandson")
        return "e.g. Nana, Papa, Gigi";
    if (rel === "Niece" || rel === "Nephew")
        return "e.g. Auntie Jo, Uncle Rob";
    if (rel === "Grandma" || rel === "Grandpa")
        return "e.g. All the grandkids";
    if (rel === "Daughter-in-law" || rel === "Son-in-law")
        return "e.g. Mom Linda, Papa Joe";
    return "e.g. Stepdaughter, all of us";
}

})(data,function(id){var deps={"@/lib/preview/quiz2":model};if(!Object.prototype.hasOwnProperty.call(deps,id))throw new Error("Missing quiz dependency");return deps[id];});
var names={};(function(exports,require){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GATE_EMAIL_RE = exports.EMAIL_SHAPE_RE = void 0;
exports.titleCaseName = titleCaseName;
exports.stripNameDecoration = stripNameDecoration;
exports.firstNameFor = firstNameFor;
exports.normalizeNewlines = normalizeNewlines;
exports.isSimpleName = isSimpleName;
exports.possessiveName = possessiveName;
exports.suggestEmailDomainFix = suggestEmailDomainFix;
function titleCaseName(value) {
    if (!value)
        return "";
    return value
        .trim()
        .split(/\s+/)
        .map((word) => {
        if (!word)
            return word;
        if (word !== word.toLowerCase())
            return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
    })
        .join(" ");
}
const DOUBLE_QUOTES = "\"“”„«»‹›`´";
const SINGLE_QUOTES = "'‘’‚‛";
const NAME_CONNECTORS = new Set(["&", "+", "/", "-", "–", "—"]);
function quotedSpans(s, family) {
    const re = new RegExp(`(^|\\s)([${family}][^${family}]*?[\\p{L}\\p{N}][^${family}]*?[${family}])(?=\\s|$)`, "gu");
    const out = [];
    let m;
    while ((m = re.exec(s))) {
        const start = m.index + m[1].length;
        out.push([start, start + m[2].length]);
    }
    return out;
}
function stripNameDecoration(value) {
    let s = (value !== null && value !== void 0 ? value : "")
        .normalize("NFC")
        .replace(/[\u0000-\u001F\u007F-\u009F\u00AD\u200B\u2060\uFEFF]/g, "")
        .replace(/\s+/g, " ")
        .trim();
    if (!s)
        return "";
    for (const family of [DOUBLE_QUOTES, SINGLE_QUOTES]) {
        const spans = quotedSpans(s, family);
        let allInside = spans.length > 0;
        for (let i = 0; i < s.length && allInside; i++) {
            if (!/[\p{L}\p{N}]/u.test(s[i]))
                continue;
            if (!spans.some(([a, b]) => i > a && i < b))
                allInside = false;
        }
        const kept = new Set();
        if (!allInside)
            for (const [a, b] of spans)
                kept.add(a).add(b - 1);
        const singles = family === SINGLE_QUOTES;
        let next = "";
        for (let i = 0; i < s.length; i++) {
            const c = s[i];
            if (!family.includes(c) || kept.has(i)) {
                next += c;
                continue;
            }
            const inner = singles &&
                i > 0 &&
                i < s.length - 1 &&
                /[\p{L}\p{N}]/u.test(s[i - 1]) &&
                /[\p{L}\p{N}]/u.test(s[i + 1]);
            if (inner)
                next += c;
        }
        s = next;
    }
    s = s
        .split(" ")
        .filter((t) => /[\p{L}\p{N}]/u.test(t) || NAME_CONNECTORS.has(t))
        .join(" ")
        .replace(/\s+,/g, ",")
        .replace(/^[\s.,;:!?*_~^|\\/+&\-–—]+/u, "")
        .replace(/[\s.,;:!?*_~^|\\/+&\-–—]+$/u, "")
        .replace(/\s+/g, " ")
        .trim();
    return s;
}
const ADDRESS_OPENERS = new Set(["for", "to", "dear", "dearest", "hi", "hello", "hey", "we", "i"]);
const HAPPY_NEXT = new Set(["birthday", "bday", "birthdays", "anniversary", "new", "mothers", "fathers", "valentines", "holidays", "christmas", "graduation", "retirement"]);
const RELATION_WORDS = new Set([
    "husband", "wife", "hubby", "spouse", "partner", "boyfriend", "girlfriend",
    "fiance", "fiancé", "fiancee", "fiancée", "mother", "father", "son",
    "daughter", "sister", "brother", "grandmother", "grandfather", "friend",
    "bestie", "cousin", "niece", "nephew", "mom", "mum", "mama", "momma",
    "mommy", "dad", "daddy", "papa", "grandma", "grandpa", "nana", "granny",
    "aunt", "auntie", "uncle", "boys", "girls", "kids", "grandkids", "family",
]);
const ADDRESS_FILLER = new Set([
    "my", "our", "your", "the", "a", "an", "all", "both", "and", "of",
    "beautiful", "sweet", "beloved", "lovely", "little", "dear", "dearest",
    "birthday", "bday", "birthdays", "anniversary", "congrats", "congratulations",
    "wishes", "wishing", "blessings", "love", "loving", "always", "forever",
    "thank", "thanks", "you", "yours", "we", "i", "to", "for", "happy",
]);
const wordOf = (t) => t.toLowerCase().replace(/[^\p{L}'’-]/gu, "");
function firstNameFor(value) {
    var _a;
    if (!value)
        return "";
    const words = stripNameDecoration(value)
        .split(" ")
        .filter((t) => /[\p{L}\p{N}]/u.test(t));
    let i = 0;
    if (words.length > 1) {
        const w0 = wordOf(words[0]);
        const w1 = wordOf(words[1]);
        const opens = ADDRESS_OPENERS.has(w0) ||
            (w0 === "happy" && HAPPY_NEXT.has(w1)) ||
            ((w0 === "my" || w0 === "our") && RELATION_WORDS.has(w1));
        if (opens) {
            i = 1;
            while (i < words.length - 1 &&
                (ADDRESS_FILLER.has(wordOf(words[i])) || RELATION_WORDS.has(wordOf(words[i])))) {
                i++;
            }
        }
    }
    const first = (_a = words[i]) !== null && _a !== void 0 ? _a : "";
    return titleCaseName(first
        .replace(/^[^\p{L}\p{N}]+|[,;:!?"“”'’)\]]+$/gu, "")
        .replace(/^(\p{L}{3,})\.$/u, "$1"));
}
function normalizeNewlines(value) {
    return value.replace(/\r\n?/g, "\n");
}
function isSimpleName(name) {
    const v = (name !== null && name !== void 0 ? name : "").trim();
    return v.length > 0 && v.length <= 14 && /^[\p{L}][\p{L}'’-]*$/u.test(v);
}
function possessiveName(name) {
    return name.slice(-1).toLowerCase() === "s" ? `${name}’` : `${name}’s`;
}
exports.EMAIL_SHAPE_RE = /^[^\s@]+@[^\s@/\\:;,<>()[\]"'`]+\.[^\s@/\\:;,<>()[\]"'`.]{2,}$/;
exports.GATE_EMAIL_RE = exports.EMAIL_SHAPE_RE;
const EMAIL_PROVIDER_DOMAINS = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "icloud.com",
    "aol.com",
    "live.com",
    "msn.com",
    "me.com",
    "mac.com",
    "comcast.net",
    "verizon.net",
    "att.net",
    "sbcglobal.net",
    "bellsouth.net",
    "cox.net",
    "charter.net",
    "optonline.net",
    "optimum.net",
    "earthlink.net",
    "juno.com",
    "ymail.com",
    "rocketmail.com",
    "protonmail.com",
    "proton.me",
    "mail.com",
    "email.com",
    "gmx.com",
    "zoho.com",
    "aim.com",
    "yandex.com",
    "hush.com",
    "fastmail.com",
];
const EMAIL_PROVIDER_SET = new Set(EMAIL_PROVIDER_DOMAINS);
function withinOneEdit(a, b) {
    if (a === b)
        return false;
    const la = a.length;
    const lb = b.length;
    if (Math.abs(la - lb) > 1)
        return false;
    let head = 0;
    while (head < la && head < lb && a[head] === b[head])
        head += 1;
    let tail = 0;
    while (tail < la - head &&
        tail < lb - head &&
        a[la - 1 - tail] === b[lb - 1 - tail]) {
        tail += 1;
    }
    return la - head - tail <= 1 && lb - head - tail <= 1;
}
function suggestEmailDomainFix(email) {
    const trimmed = email.trim();
    const at = trimmed.lastIndexOf("@");
    if (at <= 0 || at === trimmed.length - 1)
        return null;
    const local = trimmed.slice(0, at);
    if (local.includes("@"))
        return null;
    const domain = trimmed.slice(at + 1).toLowerCase();
    if (EMAIL_PROVIDER_SET.has(domain))
        return null;
    const dot = domain.indexOf(".");
    if (dot <= 0 || dot === domain.length - 1)
        return null;
    const name = domain.slice(0, dot);
    const tld = domain.slice(dot + 1);
    const hits = new Set();
    for (const provider of EMAIL_PROVIDER_DOMAINS) {
        const pDot = provider.indexOf(".");
        const providerName = provider.slice(0, pDot);
        const providerTld = provider.slice(pDot + 1);
        if (name === providerName && withinOneEdit(tld, providerTld)) {
            hits.add(provider);
            continue;
        }
        if (tld === providerTld &&
            providerName.length >= 5 &&
            withinOneEdit(name, providerName)) {
            hits.add(provider);
        }
    }
    if (hits.size !== 1)
        return null;
    return `${local}@${[...hits][0]}`;
}

})(names,function(id){var deps={};if(!Object.prototype.hasOwnProperty.call(deps,id))throw new Error("Missing quiz dependency");return deps[id];});
var recipient={};(function(exports,require){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayRecipientName = displayRecipientName;
exports.normalizeRecipientName = normalizeRecipientName;
exports.readsLikeDedication = readsLikeDedication;
exports.suggestedNames = suggestedNames;
const text_1 = require("../text");
const DESCRIPTIVE = {
    husband: "spouse",
    wife: "spouse",
    hubby: "spouse",
    spouse: "spouse",
    partner: "partner",
    boyfriend: "partner",
    girlfriend: "partner",
    fiance: "partner",
    "fiancé": "partner",
    fiancee: "partner",
    "fiancée": "partner",
    mother: "mother",
    father: "father",
    son: "child",
    daughter: "child",
    sister: "sibling",
    brother: "sibling",
    sis: "sibling",
    bro: "sibling",
    grandmother: "grandparent",
    grandfather: "grandparent",
    friend: "friend",
    bestie: "friend",
    cousin: "other",
    niece: "other",
    nephew: "other",
};
const HONORIFIC = {
    mom: "mother",
    mama: "mother",
    momma: "mother",
    mommy: "mother",
    mum: "mother",
    dad: "father",
    daddy: "father",
    papa: "father",
    pop: "father",
    grandma: "grandparent",
    granny: "grandparent",
    nana: "grandparent",
    grandpa: "grandparent",
    papaw: "grandparent",
    aunt: "other",
    auntie: "other",
    uncle: "other",
};
const ADDRESS_WORDS = new Set(["for", "to", "dear", "dearest"]);
const POSSESSIVES = new Set(["my", "our", "your"]);
const ADJECTIVES_BEFORE_RELATION = 2;
const ABBREVIATIONS = new Set([
    "dr", "mr", "mrs", "ms", "mx", "jr", "sr", "st", "prof", "fr", "rev",
    "capt", "sgt", "lt",
]);
function hasWord(map, word) {
    return Object.prototype.hasOwnProperty.call(map, word);
}
function titleCaseWord(word) {
    if (word === word.toLowerCase() || word === word.toUpperCase()) {
        const lower = word.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
    }
    return word;
}
function couldBeAName(word, lenient = false) {
    const w = word.toLowerCase().replace(/[^\p{L}'’-]/gu, "");
    if (!w)
        return false;
    if (ADDRESS_WORDS.has(w) || POSSESSIVES.has(w))
        return false;
    if (lenient)
        return true;
    if (SENTENCE_WORDS.has(w) || hasWord(DESCRIPTIVE, w))
        return false;
    return true;
}
function displayRecipientName(raw) {
    if (!(raw === null || raw === void 0 ? void 0 : raw.trim()))
        return null;
    if (!(0, text_1.stripNameDecoration)(raw))
        return null;
    const { name } = normalizeRecipientName(raw);
    const stripped = name
        .replace(/[\p{Extended_Pictographic}\u{FE0F}\u{200D}]/gu, " ")
        .replace(/,(?=\S)/g, ", ")
        .replace(/\s+/g, " ")
        .trim();
    if (!stripped)
        return null;
    const tokens = stripped.split(" ");
    const cutAt = tokens.findIndex((t, i) => i > 0 && /^(?:my|our)$/i.test(t.replace(/[^\p{L}]/gu, "")));
    let kept = cutAt > 0 ? tokens.slice(0, cutAt) : tokens;
    if (cutAt > 0 && kept.every((t) => GROUP_OPENERS.has(t.toLowerCase()))) {
        kept = tokens;
    }
    if (isNameList(kept) || GROUP_OPENERS.has(kept[0].toLowerCase())) {
        if (countNames(kept) > LIST_MAX_NAMES ||
            kept.join(" ").length > LIST_MAX_CHARS) {
            return null;
        }
    }
    else if (kept.length > 3 || kept.join(" ").length > 30) {
        kept = kept.slice(0, 1);
    }
    const trimmedDown = cutAt > 0 || kept.length < tokens.length;
    if (!couldBeAName(kept[0], !trimmedDown))
        return null;
    const result = kept.join(" ").replace(/[.,;:!\s]+$/u, "").trim();
    return result || null;
}
const LIST_JOINERS = new Set([
    "and", "&", "+", "/", "-", "–", "—", "or", "y", "e", "und", "et",
]);
const GROUP_OPENERS = new Set(["the", "all", "both", "every", "team"]);
const LIST_MAX_NAMES = 6;
const LIST_MAX_CHARS = 64;
function isNameList(tokens) {
    if (tokens.length < 2)
        return false;
    for (let i = 0; i < tokens.length - 1; i++) {
        if (/[,;]$/.test(tokens[i]))
            return true;
        if (i > 0 && LIST_JOINERS.has(tokens[i].toLowerCase()))
            return true;
    }
    return false;
}
function countNames(tokens) {
    return tokens
        .join(" ")
        .split(/[,;]|\s(?:and|or|y|e|und|et)\s|[&+/–—]|\s-\s/iu)
        .filter((part) => /[\p{L}\p{N}]/u.test(part)).length;
}
const SENTENCE_WORDS = new Set([
    "i", "im", "i'm", "ive", "i've", "he", "she", "they", "we", "you",
    "his", "hers", "theirs", "him", "them", "me", "us", "myself",
    "is", "was", "are", "were", "am", "be", "been", "being",
    "has", "have", "had", "will", "would", "can", "cant", "can't",
    "died", "die", "dies", "passed", "away", "gone", "lost", "left",
    "ago", "yrs", "yr", "years", "year", "old", "turning", "turns",
    "turned", "born", "married", "loves", "loved", "misses", "missed",
    "who", "that", "which", "because", "when", "since", "after",
    "before", "but", "so", "for",
    "happy", "birthday", "bday", "birthdays", "anniversary", "congrats",
    "congratulations", "wishes", "wishing", "wish", "blessings", "blessing",
    "love", "loving", "hugs", "kisses", "xoxo", "xo", "always", "forever",
    "thank", "thanks", "miss", "missing", "proud",
]);
const LOWER_CONNECTORS = new Set(["and", "of", "the", "or", "y", "de", "van", "der"]);
function sentenceStart(words) {
    var _a;
    const opener = ((_a = words[0]) !== null && _a !== void 0 ? _a : "").toLowerCase().replace(/^[^\p{L}']+|[^\p{L}']+$/gu, "");
    if (opener && SENTENCE_WORDS.has(opener))
        return -1;
    for (let i = 1; i < words.length; i++) {
        const stopped = /(\p{L}{2,})[.!?]+$/u.exec(words[i - 1]);
        if (stopped && !ABBREVIATIONS.has(stopped[1].toLowerCase()))
            return i;
        const w = words[i].toLowerCase().replace(/^[^\p{L}']+|[^\p{L}']+$/gu, "");
        if (w && SENTENCE_WORDS.has(w))
            return i;
    }
    return -1;
}
function normalizeRecipientName(raw) {
    var _a, _b;
    const undecorated = (0, text_1.stripNameDecoration)(raw);
    const decorated = undecorated.length > 0 && undecorated !== raw.replace(/\s+/g, " ").trim();
    const original = (undecorated || raw)
        .replace(/\s+/g, " ")
        .trim()
        .replace(/[.,;\s]+$/, "");
    if (!original)
        return { name: raw.trim(), relationshipHint: null };
    let rest = original;
    let relationshipHint = null;
    let stripped = decorated;
    const address = /^(?:for|to|dear|dearest)\s+/iu.exec(rest);
    if (address && address[0].length < rest.length) {
        rest = rest.slice(address[0].length).trim();
        stripped = true;
    }
    const possessive = /^(?:my|our)\s+(?:dear\s+|dearest\s+|sweet\s+|beloved\s+|lovely\s+)?/i.exec(rest);
    if (possessive && possessive[0].length < rest.length) {
        const afterPossessive = (() => {
            const raw = rest.slice(possessive[0].length);
            const toks = raw.split(" ");
            for (let j = 1; j <= ADJECTIVES_BEFORE_RELATION && j < toks.length; j++) {
                const cand = toks[j].toLowerCase().replace(/[^\p{L}'’-]/gu, "");
                if (hasWord(DESCRIPTIVE, cand) || hasWord(HONORIFIC, cand)) {
                    return toks.slice(j).join(" ");
                }
                if (!/^\p{L}+$/u.test(cand))
                    break;
            }
            return raw;
        })();
        const firstWordMatch = /^([\p{L}'’-]+)(\s+|$)/u.exec(afterPossessive);
        const firstWord = (_b = (_a = firstWordMatch === null || firstWordMatch === void 0 ? void 0 : firstWordMatch[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
        const remainder = firstWordMatch
            ? afterPossessive.slice(firstWordMatch[0].length)
            : "";
        if (firstWord in DESCRIPTIVE && remainder.trim()) {
            rest = remainder.trim();
            relationshipHint = DESCRIPTIVE[firstWord];
            stripped = true;
        }
        else if (firstWord in HONORIFIC) {
            rest = afterPossessive.trim();
            relationshipHint = HONORIFIC[firstWord];
            stripped = true;
        }
        else if (firstWord in DESCRIPTIVE && !remainder.trim()) {
            rest = afterPossessive.trim();
            relationshipHint = DESCRIPTIVE[firstWord];
            stripped = true;
        }
        else {
            rest = afterPossessive.trim();
            stripped = true;
        }
    }
    if (!rest.trim())
        return { name: original, relationshipHint: null };
    rest = rest.replace(/(\p{L}{2,})\.(?=\p{L})/gu, "$1. ");
    const words = rest.split(" ").filter(Boolean);
    const cut = sentenceStart(words);
    if (cut > 0) {
        const kept = words.slice(0, cut).join(" ").replace(/[.,;\s]+$/, "");
        if (kept.trim()) {
            rest = kept.trim();
            stripped = true;
            console.warn("[recipient-name] cut a sentence off the name", {
                keptWords: cut,
                droppedWords: words.length - cut,
            });
        }
    }
    const cased = rest
        .split(" ")
        .map((w, i) => i > 0 && LOWER_CONNECTORS.has(w.toLowerCase()) ? w.toLowerCase() : titleCaseWord(w))
        .join(" ");
    if (!stripped && cased === rest) {
        return { name: original, relationshipHint: null };
    }
    return { name: cased, relationshipHint };
}
function readsLikeDedication(raw) {
    const clean = (0, text_1.stripNameDecoration)(raw !== null && raw !== void 0 ? raw : "");
    if (!clean)
        return false;
    const spaced = clean.replace(/(\p{L}{2,})\.(?=\p{L})/gu, "$1. ");
    const words = spaced.split(" ").filter(Boolean);
    if (words.length === 0)
        return false;
    const first = words[0].toLowerCase().replace(/[^\p{L}]/gu, "");
    if (ADDRESS_WORDS.has(first) && words.length > 1)
        return true;
    if (sentenceStart(words) > 0)
        return true;
    if (words.length > 4 && !isNameList(words))
        return true;
    return false;
}
function suggestedNames(raw) {
    var _a, _b;
    const shown = (_a = displayRecipientName(raw)) !== null && _a !== void 0 ? _a : "";
    const out = [];
    const first = (_b = shown.split(" ")[0]) !== null && _b !== void 0 ? _b : "";
    for (const cand of [shown, first, (0, text_1.firstNameFor)(raw)]) {
        const c = cand.replace(/[.,;:!?\s]+$/u, "").trim();
        const cw = c.split(" ");
        if (!c || readsLikeDedication(c) || !couldBeAName(cw[0], shown !== "" && cw.length === 1))
            continue;
        if (!out.includes(c))
            out.push(c);
    }
    return out;
}

})(recipient,function(id){var deps={"../text":names};if(!Object.prototype.hasOwnProperty.call(deps,id))throw new Error("Missing quiz dependency");return deps[id];});
var ranks={};(function(exports,require){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRAIT_RANK = exports.VOICE_RANK = exports.MOOD_RANK = exports.STYLE_RANK = exports.OCCASION_RANK = exports.RELATIONSHIP_RANK = exports.PILL_ORDER_SNAPSHOT = void 0;
exports.PILL_ORDER_SNAPSHOT = "2026-09-25";
exports.RELATIONSHIP_RANK = [
    ["Daughter", 1],
    ["Son", 2],
    ["Granddaughter", 3],
    ["Husband", 4],
    ["Friend", 5],
    ["Grandson", 6],
    ["Sister", 7],
    ["Mom", 8],
    ["Wife", 9],
    ["Boyfriend", 10],
    ["Niece", 11],
    ["Brother", 12],
    ["Girlfriend", 13],
    ["Partner", 14],
    ["Dad", 15],
    ["Cousin", 16],
    ["Nephew", 17],
    ["Fiancé(e)", 18],
    ["Grandma", 19],
    ["Daughter-in-law", 20],
    ["Grandpa", 21],
    ["Son-in-law", 22],
];
exports.OCCASION_RANK = {
    "Daughter": [
        ["Birthday", 1],
        ["Just Because", 2],
        ["I Love You", 3],
        ["Missing You", 4],
        ["Wedding", 5],
        ["Graduation", 6],
        ["Milestone", 7],
        ["In Memory", 8],
        ["Thank You", 9],
        ["Apology", 10],
        ["Friendship", 11],
        ["Anniversary", 12],
        ["Proposal", 13],
        ["Retirement", 14],
    ],
    "Son": [
        ["Birthday", 1],
        ["Just Because", 2],
        ["I Love You", 3],
        ["In Memory", 4],
        ["Wedding", 5],
        ["Missing You", 6],
        ["Milestone", 7],
        ["Thank You", 8],
        ["Graduation", 9],
        ["Apology", 10],
        ["Anniversary", 11],
        ["Retirement", 12],
        ["Proposal", 13],
        ["Friendship", 14],
    ],
    "Granddaughter": [
        ["Birthday", 1],
        ["Just Because", 2],
        ["I Love You", 3],
        ["Missing You", 4],
        ["Graduation", 5],
        ["Wedding", 6],
        ["Milestone", 7],
        ["Thank You", 8],
        ["In Memory", 9],
        ["Friendship", 10],
        ["Anniversary", 11],
        ["Apology", 12],
        ["Proposal", 12],
        ["Retirement", 13],
    ],
    "Grandson": [
        ["Birthday", 1],
        ["Just Because", 2],
        ["I Love You", 3],
        ["In Memory", 4],
        ["Graduation", 5],
        ["Missing You", 6],
        ["Milestone", 7],
        ["Thank You", 8],
        ["Proposal", 9],
        ["Wedding", 10],
        ["Anniversary", 11],
        ["Friendship", 11],
        ["Apology", 12],
    ],
    "Husband": [
        ["Birthday", 1],
        ["Anniversary", 2],
        ["I Love You", 3],
        ["In Memory", 4],
        ["Just Because", 5],
        ["Missing You", 6],
        ["Thank You", 7],
        ["Apology", 8],
        ["Retirement", 9],
        ["Wedding", 10],
        ["Milestone", 11],
        ["Friendship", 12],
        ["Proposal", 13],
    ],
    "Mom": [
        ["Birthday", 1],
        ["In Memory", 2],
        ["Just Because", 3],
        ["I Love You", 4],
        ["Thank You", 5],
        ["Missing You", 6],
        ["Friendship", 7],
        ["Milestone", 8],
        ["Wedding", 8],
        ["Anniversary", 9],
        ["Graduation", 10],
        ["Retirement", 10],
        ["Apology", 11],
    ],
    "Sister": [
        ["Birthday", 1],
        ["Just Because", 2],
        ["In Memory", 3],
        ["Thank You", 4],
        ["I Love You", 5],
        ["Missing You", 6],
        ["Friendship", 7],
        ["Milestone", 8],
        ["Apology", 9],
        ["Anniversary", 10],
        ["Wedding", 11],
    ],
    "Friend": [
        ["Birthday", 1],
        ["Friendship", 2],
        ["Just Because", 3],
        ["Thank You", 4],
        ["Missing You", 5],
        ["In Memory", 6],
        ["I Love You", 7],
        ["Apology", 8],
        ["Milestone", 9],
        ["Anniversary", 10],
        ["Retirement", 11],
        ["Wedding", 12],
        ["Graduation", 13],
    ],
};
exports.STYLE_RANK = {
    "Daughter": [
        ["Pop", 1],
        ["Country", 2, ["Pop"]],
        ["Acoustic", 3],
        ["Gospel", 4],
        ["R&B", 5],
        ["Rock", 6],
        ["Soul", 7],
        ["Folk", 8],
        ["Blues", 9],
        ["Jazz", 10],
    ],
    "Son": [
        ["Country", 1],
        ["Pop", 2],
        ["Rock", 3],
        ["Acoustic", 4, ["Rock"]],
        ["R&B", 5],
        ["Gospel", 6],
        ["Soul", 7],
        ["Folk", 8],
        ["Blues", 9],
        ["Jazz", 10],
    ],
    "Granddaughter": [
        ["Pop", 1],
        ["Country", 2],
        ["Gospel", 3],
        ["R&B", 4],
        ["Rock", 5],
        ["Acoustic", 6],
        ["Soul", 7],
        ["Folk", 8],
        ["Jazz", 9],
        ["Blues", 10],
    ],
    "Grandson": [
        ["Pop", 1],
        ["Country", 2],
        ["Rock", 3],
        ["Acoustic", 4],
        ["R&B", 5],
        ["Gospel", 6],
        ["Soul", 7],
        ["Folk", 8, ["Soul"]],
        ["Blues", 9],
        ["Jazz", 10, ["Blues"]],
    ],
    "Husband": [
        ["Country", 1],
        ["Rock", 2],
        ["Gospel", 3],
        ["R&B", 4],
        ["Acoustic", 5],
        ["Pop", 6],
        ["Soul", 7],
        ["Jazz", 8],
        ["Blues", 9],
        ["Folk", 10],
    ],
    "Mom": [
        ["Country", 1],
        ["Gospel", 2],
        ["Acoustic", 3],
        ["Pop", 4],
        ["Soul", 5],
        ["R&B", 6],
        ["Rock", 7, ["R&B"]],
        ["Folk", 8, ["R&B", "Rock"]],
        ["Blues", 9],
        ["Jazz", 10],
    ],
    "Sister": [
        ["Country", 1],
        ["Pop", 2],
        ["Gospel", 3],
        ["Acoustic", 4],
        ["R&B", 5],
        ["Soul", 6],
        ["Rock", 7],
        ["Blues", 8],
        ["Jazz", 9],
        ["Folk", 10],
    ],
    "Friend": [
        ["Country", 1],
        ["Pop", 2],
        ["Rock", 3],
        ["Gospel", 4],
        ["Acoustic", 5],
        ["R&B", 6],
        ["Soul", 7, ["R&B"]],
        ["Jazz", 8],
        ["Folk", 9],
        ["Blues", 10],
    ],
};
exports.MOOD_RANK = {
    "Daughter": [
        ["Heartfelt", 1],
        ["Uplifting", 2],
        ["Joyful", 3],
        ["Playful", 4],
        ["Sentimental", 5],
        ["Peaceful", 6, ["Sentimental"]],
        ["Reflective", 7],
        ["Hopeful", 8],
    ],
    "Son": [
        ["Heartfelt", 1],
        ["Uplifting", 2],
        ["Playful", 3],
        ["Joyful", 4],
        ["Peaceful", 5],
        ["Reflective", 6],
        ["Sentimental", 7],
    ],
    "Granddaughter": [
        ["Heartfelt", 1],
        ["Joyful", 2],
        ["Uplifting", 3],
        ["Playful", 4, ["Uplifting"]],
        ["Peaceful", 5],
        ["Sentimental", 6],
    ],
    "Grandson": [
        ["Heartfelt", 1],
        ["Playful", 2],
        ["Joyful", 3],
        ["Uplifting", 4],
        ["Peaceful", 5],
    ],
    "Husband": [
        ["Heartfelt", 1],
        ["Romantic", 2],
        ["Sentimental", 3],
        ["Playful", 4],
        ["Joyful", 5],
        ["Peaceful", 6],
        ["Reflective", 7],
        ["Hopeful", 8],
    ],
    "Mom": [
        ["Heartfelt", 1],
        ["Sentimental", 2],
        ["Reflective", 3],
        ["Joyful", 4],
        ["Peaceful", 5, ["Joyful"]],
        ["Uplifting", 6],
    ],
    "Sister": [
        ["Heartfelt", 1],
        ["Sentimental", 2],
        ["Uplifting", 3],
        ["Joyful", 4],
        ["Reflective", 5],
        ["Peaceful", 6],
    ],
    "Friend": [
        ["Heartfelt", 1],
        ["Uplifting", 2],
        ["Joyful", 3],
        ["Sentimental", 4],
        ["Reflective", 5],
        ["Peaceful", 6],
    ],
};
exports.VOICE_RANK = {
    "Daughter": [
        ["Female voice", 1],
        ["Male voice", 2],
        ["Surprise Me", 3],
    ],
    "Son": [
        ["Female voice", 1],
        ["Male voice", 2],
    ],
    "Granddaughter": [
        ["Female voice", 1],
        ["Male voice", 2],
    ],
    "Grandson": [
        ["Female voice", 1],
        ["Male voice", 2],
    ],
    "Husband": [
        ["Female voice", 1],
        ["Male voice", 2],
    ],
    "Mom": [
        ["Female voice", 1],
        ["Male voice", 2],
    ],
    "Sister": [
        ["Female voice", 1],
        ["Male voice", 2],
    ],
    "Friend": [
        ["Female voice", 1],
        ["Male voice", 2],
    ],
};
exports.TRAIT_RANK = {
    "Daughter": {
        measured: [
            ["Loving", 1],
            ["Kind", 2],
            ["Big heart", 3],
            ["Thoughtful", 4],
            ["Caring", 5],
            ["Determined", 6],
            ["Funny", 7],
            ["Brave", 8],
            ["Generous", 9],
            ["Loves animals", 10],
            ["Bright", 11],
            ["Big feelings", 12],
            ["Friends with all", 13],
            ["Full of joy", 14],
            ["Fearless", 15],
            ["Clever", 16],
            ["Stubborn", 17],
            ["Gentle", 18],
            ["Makes me proud", 19],
            ["Strong", 20],
            ["An old soul", 21],
            ["Still my baby", 22],
            ["Dances everywhere", 23],
            ["Beautiful soul", 24],
            ["Never stops talking", 25],
            ["Wants to help", 26],
            ["My sunshine", 27],
            ["Hardworking", 28],
            ["Curious", 29],
            ["Never gives up", 30],
            ["My best friend", 31],
            ["Always helping others", 32],
            ["Never still", 33],
            ["Creative", 34],
            ["Bad at losing", 35],
            ["Laughs at nothing", 36],
            ["Grew up too fast", 37],
            ["Tells long stories", 38],
            ["Sings made-up songs", 39],
            ["Collects everything", 40],
            ["Asks why forever", 41],
            ["Best hugs", 42],
            ["Runs everywhere", 43],
            ["Life of the party", 44],
            ["Asks for one more", 45],
            ["Hates bedtime", 46],
            ["Draws on walls", 47],
            ["Always muddy", 48],
            ["Copies everything", 49],
        ],
        belowFloor: [],
    },
    "Son": {
        measured: [
            ["Big heart", 1],
            ["Loving", 2],
            ["Kind", 3],
            ["Funny", 4],
            ["Thoughtful", 5],
            ["Determined", 6],
            ["Caring", 7],
            ["Brave", 8],
            ["Generous", 9],
            ["Friends with all", 10],
            ["Clever", 11],
            ["Gentle", 12],
            ["Bright", 13],
            ["Big feelings", 14],
            ["Makes me proud", 15],
            ["Fearless", 16],
            ["Stubborn", 17],
            ["Loves animals", 18],
            ["Full of joy", 19],
            ["An old soul", 20],
            ["Strong", 21],
            ["Curious", 22],
            ["Hardworking", 23],
            ["Still my baby", 24],
            ["Wants to help", 25],
            ["Never gives up", 26],
            ["Beautiful soul", 27],
            ["Bad at losing", 28],
            ["Never stops talking", 29],
            ["My sunshine", 30],
            ["Always helping others", 31],
            ["Creative", 32],
            ["Never still", 33],
            ["Grew up too fast", 34],
            ["Best hugs", 35],
            ["Dances everywhere", 36],
            ["Tells long stories", 37],
            ["Laughs at nothing", 38],
            ["My best friend", 39],
            ["Collects everything", 40],
            ["Sings made-up songs", 41],
            ["Asks why forever", 42],
            ["Life of the party", 43],
            ["Hates bedtime", 44],
            ["Runs everywhere", 45],
            ["Asks for one more", 46],
            ["Draws on walls", 47],
            ["Always muddy", 48],
            ["Copies everything", 49],
        ],
        belowFloor: [],
    },
    "Granddaughter": {
        measured: [
            ["Loving", 1],
            ["Kind", 2],
            ["Big heart", 3],
            ["Thoughtful", 4],
            ["Funny", 5],
            ["Caring", 6],
            ["Determined", 7],
            ["Bright", 8],
            ["Full of joy", 9],
            ["Brave", 10],
            ["Loves animals", 11],
            ["Friends with all", 12],
            ["Generous", 13],
            ["Big feelings", 14],
            ["Gentle", 15],
            ["Dances everywhere", 16],
            ["Clever", 17],
            ["Fearless", 18],
            ["Curious", 19],
            ["Never stops talking", 20],
            ["Stubborn", 21],
            ["Makes me proud", 22],
            ["Wants to help", 23],
            ["An old soul", 24],
            ["Strong", 25],
            ["Beautiful soul", 26],
            ["My sunshine", 27],
            ["Sings made-up songs", 28],
            ["Never still", 29],
            ["Creative", 30],
            ["Grew up too fast", 31],
            ["Laughs at nothing", 32],
            ["Asks for one more", 33],
            ["Bad at losing", 34],
            ["Collects everything", 35],
            ["Never gives up", 36],
            ["Hardworking", 37],
            ["Always helping others", 38],
            ["Tells long stories", 39],
            ["Still my baby", 40],
            ["Best hugs", 41],
            ["Hates bedtime", 42],
            ["Runs everywhere", 43],
            ["Asks why forever", 44],
            ["My best friend", 45],
            ["Copies everything", 46],
            ["Draws on walls", 47],
            ["Life of the party", 48],
            ["Always muddy", 49],
        ],
        belowFloor: [],
    },
    "Grandson": {
        measured: [
            ["Kind", 1],
            ["Loving", 2],
            ["Funny", 3],
            ["Big heart", 4],
            ["Thoughtful", 5],
            ["Caring", 6],
            ["Determined", 7],
            ["Brave", 8],
            ["Full of joy", 9],
            ["Clever", 10],
            ["Bright", 11],
            ["Friends with all", 12],
            ["Big feelings", 13],
            ["Gentle", 14],
            ["Curious", 15],
            ["Generous", 16],
            ["Loves animals", 17],
            ["Makes me proud", 18],
            ["Fearless", 19],
            ["Strong", 20],
            ["Never stops talking", 21],
            ["Stubborn", 22],
            ["My sunshine", 23],
            ["An old soul", 24],
            ["Best hugs", 25],
            ["Bad at losing", 26],
            ["Wants to help", 27],
            ["Never still", 28],
            ["Never gives up", 29],
            ["Grew up too fast", 30],
            ["Always helping others", 31],
            ["Beautiful soul", 32],
            ["Creative", 33],
            ["Hardworking", 34],
            ["Dances everywhere", 35],
            ["Still my baby", 36],
            ["Runs everywhere", 37],
            ["Asks why forever", 38],
            ["Life of the party", 39],
            ["Hates bedtime", 40],
            ["Laughs at nothing", 41],
            ["Collects everything", 42],
            ["Tells long stories", 43],
            ["Sings made-up songs", 44],
            ["Asks for one more", 45],
            ["My best friend", 46],
            ["Copies everything", 47],
            ["Draws on walls", 48],
        ],
        belowFloor: [
            "Always muddy",
        ],
    },
    "Husband": {
        measured: [
            ["My best friend", 1],
            ["Loving", 2],
            ["My safe place", 3],
            ["Always there", 4],
            ["Makes me laugh", 5],
            ["Strong", 6],
            ["Supportive", 7],
            ["Kind", 8],
            ["Generous", 9],
            ["Thoughtful", 10],
            ["Fixes everything", 11],
            ["Still holds my hand", 12],
            ["Honest", 13],
            ["Patient", 14],
            ["Gentle", 15],
            ["Best hugs", 16],
            ["Stubborn", 17],
            ["Snores", 18],
            ["Makes the coffee", 19],
            ["Warm", 20],
            ["Talks to the dog", 21],
            ["Remembers it all", 22],
            ["Can't sit still", 23],
            ["Sings in the car", 24],
            ["Steals the covers", 25],
            ["Hopeless romantic", 26],
            ["Always hungry", 27],
            ["Terrible dancer", 28],
            ["Plans everything", 29],
            ["Bad at surprises", 30],
            ["Cries at films", 31],
            ["Never lets me win", 32],
            ["Terrible at lying", 33],
            ["Never on time", 34],
            ["Always cold", 35],
            ["Overpacks", 36],
        ],
        belowFloor: [],
    },
    "Mom": {
        measured: [
            ["Loving", 1],
            ["Always there", 2],
            ["Strong", 3],
            ["Selfless", 4],
            ["Kind", 5],
            ["Generous", 6],
            ["Proud of me", 7],
            ["My biggest fan", 8],
            ["Hardworking", 9],
            ["Devoted", 10],
            ["Wise", 11],
            ["Forgiving", 12],
            ["Patient", 13],
            ["Gentle", 14],
            ["Stubborn", 15],
            ["Always busy", 16],
            ["Same advice twice", 17],
            ["Lists for everything", 18],
            ["Sunday roast", 19],
            ["Always early", 20],
            ["Fed everyone", 21],
            ["Asked for nothing", 22],
            ["Called to check", 23],
            ["Never complained", 24],
            ["Never sat down", 25],
            ["Fixed everything", 26],
            ["Gave up everything", 27],
            ["Made it from scratch", 28],
            ["Waited up", 29],
            ["Bad jokes", 30],
            ["Danced in the kitchen", 31],
            ["Kept my drawings", 32],
            ["Worried out loud", 33],
            ["Sang while cooking", 34],
        ],
        belowFloor: [
            "Drove me everywhere",
            "Cried at everything",
        ],
    },
    "Sister": {
        measured: [
            ["Supportive", 1],
            ["Strong", 2],
            ["My best friend", 3],
            ["Thoughtful", 4],
            ["Kind", 5],
            ["Has my back", 6],
            ["Loyal", 7],
            ["Generous", 8],
            ["Fun", 9],
            ["Funny", 10],
            ["Protective", 11],
            ["My first call", 12],
            ["Honest", 13],
            ["Knows my secrets", 14],
            ["Would fight for me", 15],
            ["Talented", 16],
            ["Makes me cry laughing", 17],
            ["Remembers it all", 18],
            ["Partner in crime", 19],
            ["Knows me too well", 20],
            ["Stubborn", 21],
            ["Always right", 22],
            ["Softer than they look", 23],
            ["Covered for me", 24],
            ["Always loudest", 25],
            ["Competitive", 26],
            ["Steals my clothes", 27],
            ["Started every fight", 28],
            ["Never texts back", 29],
            ["Total chaos", 30],
            ["Calls at odd hours", 31],
            ["A bad influence", 32],
            ["Beat me at everything", 33],
        ],
        belowFloor: [
            "Steals my food",
            "Copies my haircut",
            "Never lost a game",
        ],
    },
    "Friend": {
        measured: [
            ["Kind", 1],
            ["Big-hearted", 2],
            ["Thoughtful", 3],
            ["Funny", 4],
            ["Loyal", 5],
            ["Always there", 6],
            ["One in a million", 7],
            ["Easy to talk to", 8],
            ["Generous", 9],
            ["Fun", 10],
            ["Genuine", 11],
            ["Honest", 12],
            ["Dependable", 13],
            ["Warm", 14],
            ["Knows me too well", 15],
            ["Always shows up", 16],
            ["Up for anything", 17],
            ["Never judges", 18],
            ["Brutally honest", 19],
            ["Remembers it all", 20],
            ["Best advice", 21],
            ["Never forgets a birthday", 22],
            ["Feeds everyone", 23],
            ["Good bad influence", 24],
            ["First one there", 25],
            ["Answers at 3am", 26],
            ["Quietly steady", 27],
            ["Loud", 28],
            ["Sends the memes", 29],
            ["Last to leave", 30],
            ["Competitive", 31],
            ["Plans nothing", 32],
            ["Always late", 33],
            ["Terrible at goodbyes", 34],
            ["Terrible dancer", 35],
            ["Cries at films", 36],
        ],
        belowFloor: [],
    },
};

})(ranks,function(id){var deps={};if(!Object.prototype.hasOwnProperty.call(deps,id))throw new Error("Missing quiz dependency");return deps[id];});
var order={};(function(exports,require){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEMORIAL_SOUND_KEEPS_TODAY = exports.TIE_BREAK_BY_RATE = exports.ADDED_TRAITS_FOR = exports.ADDED_TRAITS = exports.TRAITS_LEAD = exports.OCC_PINNED_FIRST = exports.REL_PINNED_LAST = exports.TRAITS_KEEP_TODAY = exports.NEAREST = void 0;
exports.dataSourceFor = dataSourceFor;
exports.failSafe = failSafe;
exports.applyTie = applyTie;
exports.orderRelationships = orderRelationships;
exports.orderOccasions = orderOccasions;
exports.addedTraits = addedTraits;
exports.orderTraits = orderTraits;
exports.orderStyles = orderStyles;
exports.orderMoods = orderMoods;
exports.orderVoices = orderVoices;
const pill_order_generated_ts_1 = require("./pill-order.generated.ts");
exports.NEAREST = {
    Wife: "Husband", Boyfriend: "Husband", Girlfriend: "Husband",
    Partner: "Husband", "Fiancé(e)": "Husband", "Fiancé": "Husband",
    Dad: "Mom", Grandma: "Mom", Grandpa: "Mom", Grandparent: "Mom",
    Brother: "Sister", Cousin: "Sister", Sibling: "Sister",
    Niece: "Daughter", Nephew: "Son",
    "Daughter-in-law": "Daughter", "Son-in-law": "Son",
};
exports.TRAITS_KEEP_TODAY = new Set([
    "Daughter-in-law", "Son-in-law", "Cousin",
]);
exports.REL_PINNED_LAST = ["Myself", "Someone else"];
exports.OCC_PINNED_FIRST = "Birthday";
exports.TRAITS_LEAD = 12;
exports.ADDED_TRAITS = [
    "Honest", "Loyal", "Warm", "Patient", "Selfless", "Genuine",
];
exports.ADDED_TRAITS_FOR = new Set(["Daughter", "Son"]);
exports.TIE_BREAK_BY_RATE = true;
exports.MEMORIAL_SOUND_KEEPS_TODAY = true;
const MEMORIAL_LABEL = "In Memory";
const SURPRISE_LABEL = "Surprise Me";
const own = (o, k) => Object.prototype.hasOwnProperty.call(o, k);
function dataSourceFor(rel) {
    if (own(pill_order_generated_ts_1.TRAIT_RANK, rel) || own(pill_order_generated_ts_1.OCCASION_RANK, rel))
        return rel;
    if (own(exports.NEAREST, rel))
        return exports.NEAREST[rel];
    return null;
}
function ranksFor(table, rel) {
    const src = dataSourceFor(rel);
    return src !== null && own(table, src) ? table[src] : null;
}
function isPermutation(out, expected) {
    var _a;
    if (!Array.isArray(out) || out.length !== expected.length)
        return false;
    const n = new Map();
    for (const x of expected)
        n.set(x, ((_a = n.get(x)) !== null && _a !== void 0 ? _a : 0) + 1);
    for (const x of out) {
        const c = n.get(x);
        if (typeof x !== "string" || !c)
            return false;
        n.set(x, c - 1);
    }
    return true;
}
function failSafe(input, expected, rule) {
    try {
        const out = rule();
        if (isPermutation(out, expected))
            return [...out];
    }
    catch (_a) {
    }
    return [...input];
}
function rank(list, rows, keyOf = (s) => s, skip = () => false) {
    const index = new Map();
    for (const r of rows) {
        const k = keyOf(r[0]);
        if (!index.has(k))
            index.set(k, r);
    }
    const measured = [];
    const unmeasured = [];
    list.forEach((label, i) => {
        var _a;
        const r = skip(label) ? undefined : index.get(keyOf(label));
        if (r)
            measured.push({ label, rank: r[1], beats: (_a = r[2]) !== null && _a !== void 0 ? _a : [], i });
        else
            unmeasured.push(label);
    });
    measured.sort((a, b) => a.rank - b.rank || a.i - b.i);
    return { measured, unmeasured };
}
function applyTie(seq, byRate) {
    const out = [...seq];
    if (!byRate)
        return out;
    let i = 0;
    while (i + 1 < out.length) {
        const cur = out[i];
        const next = out[i + 1];
        if (next.beats.includes(cur.label)) {
            out[i] = next;
            out[i + 1] = cur;
            i += 2;
        }
        else {
            i += 1;
        }
    }
    return out;
}
function orderRelationships(list) {
    return failSafe(list, list, () => {
        const pinned = list.filter((r) => exports.REL_PINNED_LAST.includes(r));
        const rest = list.filter((r) => !exports.REL_PINNED_LAST.includes(r));
        const { measured, unmeasured } = rank(rest, pill_order_generated_ts_1.RELATIONSHIP_RANK);
        return [...measured.map((m) => m.label), ...unmeasured, ...pinned];
    });
}
function orderOccasions(rel, list) {
    return failSafe(list, list, () => {
        const at = list.indexOf(exports.OCC_PINNED_FIRST);
        const lead = at >= 0 ? [list[at]] : [];
        const rest = at >= 0 ? [...list.slice(0, at), ...list.slice(at + 1)] : [...list];
        const rows = ranksFor(pill_order_generated_ts_1.OCCASION_RANK, rel);
        if (!rows)
            return [...lead, ...rest];
        const { measured, unmeasured } = rank(rest, rows);
        return [...lead, ...measured.map((m) => m.label), ...unmeasured];
    });
}
function addedTraits(rel) {
    return exports.ADDED_TRAITS_FOR.has(rel) ? [...exports.ADDED_TRAITS] : [];
}
const traitKeyOf = (s) => s.replace(/[‘’]/g, "'").trim().toLowerCase();
function orderTraits(rel, list) {
    const have = new Set(list.map(traitKeyOf));
    const extended = [...list, ...addedTraits(rel).filter((t) => !have.has(traitKeyOf(t)))];
    return failSafe(list, extended, () => {
        const counts = exports.TRAITS_KEEP_TODAY.has(rel) ? null : ranksFor(pill_order_generated_ts_1.TRAIT_RANK, rel);
        if (!counts)
            return [...extended];
        const below = new Set(counts.belowFloor.map(traitKeyOf));
        const isBelow = (s) => below.has(traitKeyOf(s));
        const { measured, unmeasured } = rank(extended.filter((t) => !isBelow(t)), counts.measured, traitKeyOf);
        const labels = measured.map((m) => m.label);
        return [
            ...labels.slice(0, exports.TRAITS_LEAD),
            ...unmeasured,
            ...labels.slice(exports.TRAITS_LEAD),
            ...extended.filter(isBelow),
        ];
    });
}
function orderSound(rows, list, byRate) {
    return failSafe(list, list, () => {
        if (!rows)
            return [...list];
        const { measured, unmeasured } = rank(list, rows, undefined, (s) => s === SURPRISE_LABEL);
        return [...applyTie(measured, byRate).map((m) => m.label), ...unmeasured];
    });
}
function orderStyles(rel, occasion, list, byRate = exports.TIE_BREAK_BY_RATE) {
    if (exports.MEMORIAL_SOUND_KEEPS_TODAY && occasion === MEMORIAL_LABEL)
        return [...list];
    return orderSound(ranksFor(pill_order_generated_ts_1.STYLE_RANK, rel), list, byRate);
}
function orderMoods(rel, occasion, list, byRate = exports.TIE_BREAK_BY_RATE) {
    if (exports.MEMORIAL_SOUND_KEEPS_TODAY && occasion === MEMORIAL_LABEL)
        return [...list];
    return orderSound(ranksFor(pill_order_generated_ts_1.MOOD_RANK, rel), list, byRate);
}
function orderVoices(rel, list, byRate = exports.TIE_BREAK_BY_RATE) {
    return orderSound(ranksFor(pill_order_generated_ts_1.VOICE_RANK, rel), list, byRate);
}

})(order,function(id){var deps={"./pill-order.generated.ts":ranks};if(!Object.prototype.hasOwnProperty.call(deps,id))throw new Error("Missing quiz dependency");return deps[id];});
window.SBQ_PAID_ENGINE=Object.assign({},model,data,names,order,{readsLikeDedication:recipient.readsLikeDedication,suggestedNames:recipient.suggestedNames});
})();
